const { REACT_APP_BME_URL } = process.env;

export const KnowledgeTypeList = [
  {
    name: 'Business Operations',
    slug: 'businessOperations',
    path: 'knowledge-base/business-operations',
    description: '',
    nestedSubMenu: {
      products: [
        {
          name: 'Starting and Running a Successful iGaming Business',
          slug: 'iGamingBusiness',
          icon: '',
          path: 'business-operations/igaming-business',
          description: 'Understanding the process behind the success of an iGaming business and making it all work.\n',
        },
        {
          name: 'Choosing a Software Provider',
          slug: 'softwareProvider',
          icon: '',
          path: 'business-operations/software-provider',
          description: 'All about finding the right iGaming software provider for your operation.\n',
        },
        {
          name: 'Choosing a Market',
          slug: 'market',
          icon: '',
          path: 'business-operations/market',
          description: 'The ultimate advice on researching your' +
            ' potential iGaming business market and picking up the right target audience for your brand\n',
        },
        {
          name: 'Choosing a Licence',
          slug: 'licence',
          icon: '',
          path: 'business-operations/licence',
          description: 'How to be considered a trustworthy, responsible' +
            ' iGaming operator and carry out your online gambling operations' +
            ' on a legal basis, with a proper iGaming licence. \n',
        },
        {
          name: 'Promoting Your iGaming Operation / Player Acquisition and Retention',
          slug: 'acquisitionAndRetention',
          icon: '',
          path: 'business-operations/acquisition-and-retention',
          description: 'The promotion of your iGaming operation' +
            ' is directly or indirectly related to player' +
            ' acquisition and retention. Learn more.\n',
        },
        {
          name: 'Managing Risks',
          slug: 'risks',
          icon: '',
          path: 'business-operations/risks',
          description: 'AI-powered and ML-based real-time ' +
            'risk management systems are an important factor ' +
            'to take into account when choosing an iGaming ' +
            'software provider. Learn more.\n',
        },
      ]
    }
  },
  {
    name: 'Content Management',
    slug: 'contentManagement',
    path: 'knowledge-base/content-management',
    description: '',
    nestedSubMenu: {
      products: [
        {
          name: 'Artificial Intelligence and Machine Learning in the iGaming Industry',
          slug: 'aiAndMl',
          icon: '',
          path: 'content-management/aiAndMl',
          description: 'Online gaming is currently' +
            ' among the top industries that effectively' +
            ' use the power of artificial intelligence' +
            ' and machine-learning systems. Read on.\n',
        },
        {
          name: 'SpringBuilder',
          slug: 'springBuilder',
          path: 'content-management/springBuilder',
          icon: '',
          description: 'Create and manage your iGaming ' +
            'website with the drag-and-drop technology of' +
            ' this full-scale gaming and betting website builder.' +
            ' Powerful marketing and design tools. Highly ' +
            'customisable features. No technical skills required.\n',
        },
      ],
    },
  },
  {
    name: 'Products and Solutions',
    slug: 'productsAndSolutions',
    path: 'knowledge-base/products-and-solutions',
    description: '',
    nestedSubMenu: {
      products: [
        {
          name: 'Land-based solutions',
          slug: 'landbasedSolutions',
          path: 'products-and-solutions/land-based-solutions',
          icon: '',
          description: 'Set up new businesses from scratch or expand' +
            ' established ones enabling players to bet on both ' +
            'real-time sports and virtual games in physical locations',
        },
        {
          name: 'Poker',
          slug: 'poker',
          path: 'products-and-solutions/poker',
          icon: '',
          description: 'Poker games with intuitive design and highly-customisable settings\n',
        },
        {
          name: 'Virtual Sports',
          slug: 'virtualSports',
          path: 'products-and-solutions/virtual-sports',
          icon: '',
          description: 'Real-money betting on various 3D-designed sports\n',
        },
        {
          name: 'Casino Suite',
          slug: 'casinoSuite',
          path: 'products-and-solutions/casino-suite',
          icon: '',
          description: '7,000 casino games from BetConstruct and other major suppliers\n',
        },
        {
          name: 'Esports',
          slug: 'esports',
          path: 'products-and-solutions/esports',
          icon: '',
          description: 'Make bets on the most famous Esports' +
            ' championships: LoL, Overwatch, CS:GO, DOTA2, KoG, Starcraft, and more.',
        },
        {
          name: 'Live Casino',
          slug: 'liveCasino',
          path: 'products-and-solutions/live-casino',
          icon: '',
          description: 'Enjoy the multi-profile, highly customisable,' +
            ' user-friendly and ever-growing portfolio of Live Casino games.\n',
        },
        {
          name: 'Predictor',
          slug: 'predictor',
          path: 'products-and-solutions/predictor',
          icon: '',
          description: 'Drive higher traffic and attract' +
            ' more bettors with this free-to-play, ' +
            'no-licence and easy-to-integrate forecast game.\n',
        },
        {
          name: 'Umbrella',
          slug: 'umbrella',
          path: 'products-and-solutions/umbrella',
          icon: '',
          description: 'All about the ​​AI-powered' +
            ' risk management solution designed to identify ' +
            'and manage potential risks.\n',
        },
        {
          name: 'Sportsbook',
          slug: 'sportsbook',
          path: 'products-and-solutions/sportsbook',
          icon: '',
          description: 'A fully-managed sports-betting' +
            ' solution that provides your players with 70,000' +
            ' live matches in 20+ languages\n',
        },
        {
          name: 'CRM',
          slug: 'crm',
          path: 'products-and-solutions/crm',
          icon: '',
          description: 'Create targeted campaigns ' +
            'with the widest range of marketing tools and player ' +
            'management solutions currently available in the market.\n',
        },
        {
          name: 'BetCloud',
          slug: 'betCloud',
          path: 'products-and-solutions/bet-cloud',
          icon: '',
          description: 'Accept bets that exceed the pre-defined ' +
            'limits and share the risks within this virtual network ' +
            'for BetConstruct’s partner operators.\n',
        },
        {
          name: 'Agent System',
          slug: 'agentSystem',
          path: 'products-and-solutions/agent-system',
          icon: '',
          description: 'Nourish relationships between' +
            ' agents and players. Turn those into transactions.' +
            ' Grow business and revenues in an easy, efficient' +
            ' and profitable way.',
        },
        {
          name: 'Affiliate Marketing',
          slug: 'affiliateMarketing',
          path: 'products-and-solutions/affiliate-marketing',
          icon: '',
          description: 'One of the most complete affiliate ' +
            'creation and management solutions in the iGaming market today.\n',
        },
      ]
    },
  },
];

export const KnowledgeList = [
  {
    name: 'Starting and Running a Successful iGaming Business',
    slug: 'iGamingBusiness',
    icon: '',
    path: 'business-operations/igaming-business',
    shortDescription: 'Understanding the process behind the success of an iGaming business and making it all work.',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/riskManagement.png').default} width="689" alt="">
</div>
<br>
<h2 ><span>INTRO</span></h2>
<p><span><span><img src=${require('../assets/imgs/innerIcons/Intro.png').default} width="689" alt=""></span></span></p>
<p ><span>The success of an iGaming business normally depends on the right choice of the licence, budget and market. It is important to understand the responsibility behind the entire process. It&rsquo;s not merely about paying the setup fee and enjoying the end result right away.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Making it all work is not as easy as it may seem. It will take tremendous efforts to start your own operation and become profitable in the iGaming industry. But first, make sure to consider following the below-mentioned key steps involved in the process.</span></p>
<p><span><span>&nbsp;</span></span></p>
<h2 ><span>GET A LICENCE</span></h2>
<p><span><span>&nbsp;
<img src=${require('../assets/imgs/innerIcons/GetLicence.png').default} width="689" alt="">
</span></span></p>
<p ><span>It is crucial to obtain a licence for your iGaming business if you intend to operate as a legal entity. For this, the primary aspect to consider is your location. Gaming laws and restrictions vary from country to country, from region to region. To receive a valid iGaming licence, you will need to prove to the concerned authorities that you stick to all the conditions. It normally requires a lot of due diligence and research.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>You will need to consider&nbsp;</span></p>
<ul>
<li >
<p ><span>which licences are required in the country where your company is registered and&nbsp;</span></p>
</li>
<li >
<p ><span>which licences are required to operate in the jurisdiction of your target audience.&nbsp;</span></p>
</li>
</ul>
<p><span><span>&nbsp;</span></span></p>
<p ><span>It is often recommended to get </span><span>a lawyer</span><span> with experience in the iGaming industry. Establishing an online-operating company comes with various legal requirements. There may be many rules and regulations for the gaming industry. Before launching your iGaming operation, find out the necessary licences that are required in your jurisdiction, because your operation cannot legally operate without them.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Some iGaming licences cover all forms of gaming while other jurisdictions require having different licences for each type of gaming. Go for a gaming licence from a jurisdiction with friendly tax laws; where the licence fees are reasonable and where the licence is accepted in a wide range of countries.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>In general, the gaming industry has 4 different jurisdiction categories:</span></p>
<p><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>countries that control iGaming within their area</span></p>
</li>
<li >
<p ><span>countries that have banned iGaming</span></p>
</li>
<li >
<p ><span>countries that have monopolies</span></p>
</li>
<li >
<p ><span>countries that have no set of rules</span></p>
</li>
</ul>
<p><span><span>&nbsp;</span></span></p>
<p ><span>The easiest way to establish an iGaming business is to work with a software provider that already has the licence and the experience. They will cover all legal and regulatory aspects while also providing a payment gateway, games, and management tools.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Thus, you can either operate with your own licence or use the one from a software provider like BetConstruct, for example.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Choosing to work with the software provider&rsquo;s licence will mean going for the</span><span>white label</span><span> option.&nbsp;</span></p>
</li>
<li >
<p ><span>Operating with your own licence will imply going for the </span><span>turnkey </span><span>option. But even in this scenario, BetConstruct helps its turnkey partners obtain a licence.</span></p>
</li>
</ol>
<p><span><span>&nbsp;</span></span></p>
<h2 ><span>PICK A TRUSTWORTHY SOFTWARE PROVIDER</span></h2>
<p><span><span>&nbsp;
<img src=${require('../assets/imgs/innerIcons/Picktrustworthyoftware.png').default} width="689" alt="">

</span></span></p>
<p ><span>iGaming as such is not a very new industry. So you&rsquo;ll be facing many of the existing competitors as you start your own business. The good news is that you don&rsquo;t have to build it all from scratch. There are multiple resources available for this market, and you can always go for various ready-to-operate iGaming platforms.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>These days, it is possible to find decent-budget solutions without compromising on the quality. Take a good look at your budget. Do your research. Choose the most suitable option for you.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Finding a reliable software provider is perhaps your most critical choice when starting an iGaming operation. The quality of your website and the user-experience it offers largely depends on your software. Ensure that your software provider has got experience in online gambling and betting; offers customisable software; supports multiple payment options and has an advanced gaming management system. Check who they are, their partners, how good they are as operators, what products they offer, read feedback and reviews.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>If you know little about software or want the quickest solution, then </span><span>white label </span><span>is for you. White label is the cheapest option to enter the market. With white label, the business is already set up, and there are no big risks. The website is already made: you just add your brand name and design. Make sure that your gaming website is mobile-friendly and that the software offers players such options as live games, mobile games, multi-players etc.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Of course, your skilled in-house team could develop the software, and that&rsquo;s a brave idea. But the best solution would be to find an iGaming software provider with the right tool sets and prerequisites. When choosing a provider, it is best to select one that offers quality software at a price that matches your budget.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>A trustworthy and good software provider is supposed to have the following services:</span></p>
<ul>
<li >
<p ><span>Great customer support</span></p>
</li>
<li >
<p ><span>A gaming management system</span></p>
</li>
<li >
<p ><span>Premium quality back-end tools</span></p>
</li>
<li >
<p ><span>Payment gateways that have a multi-currency support</span></p>
</li>
<li >
<p ><span>An easy-to-navigate front-end</span></p>
</li>
<li >
<p ><span>Access to well-known online games and events</span></p>
</li>
</ul>
<p><span><span><br /><br /></span></span></p>
<p ><span>BetConstruct has over 16 offices in various countries worldwide. This makes the entire process easier. [More about this?]</span></p>
<p><span><span><br /><br /></span></span></p>
<h2 ><span>EXTENSIVE PROMOTION AND MARKETING</span></h2>
<p><span><span>&nbsp
<img src=${require('../assets/imgs/innerIcons/ExtensivePromotionMarketing.png').default} width="689" alt="">

</span></span></p>
<p ><span>Once you&rsquo;ve started, you will need to promote your iGaming operation in every possible way. Highlight the strongest features of your business to sell your product to prospective players. Come up with unique offers in the form of captivating games, free bets, bonuses, etc. Whatever your strengths are, specify them and spread the word.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Promoting an iGaming operation can get a bit pricey depending on which medium you decide to use.&nbsp; Facebook advertisement, for example, can be a bit tricky: you agree to a minimum spend and submit an application to be approved for advertising online gambling.&nbsp; With PPC campaigns, the cost per click for online gaming is greater than what you can expect with most companies. This doesn&rsquo;t actually need to be a negative; it simply means you have to make sure you spend your money carefully and track your return on investment on an ongoing basis to see which platforms are working for you.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>The iGaming advertising market has its specifics and nuances. For instance, there are many social media restrictions. Also, Google frequently blocks most operations. You will need an outstanding marketing strategy for social media marketing, gambling forums, articles, blogs and online advertising using search words and SEO. Good marketing campaigns call for generous investments but require meticulous preparation, hard work and luck.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Additionally, the conversion rate in iGaming business is quite low, while the cost-per-acquisition is rather high. In other words, it costs a lot to pull a player out of their favourite online gaming platform: they either need to get disappointed in that provider or your offers have to be really outstanding. Apart from visible outward advertising, it&rsquo;s actually your business&rsquo;s internal offers that can do the best promotion for your operation: this includes your bonuses, jackpots, free rolls, free spins, etc. In your advertising, you need to be more appealing than your opponents.</span></p>
<h4 ><span>So how can your business stand out from the rest?</span></h4>
<ul>
<li >
<p ><span>Form a marketing team with a deep experience in the iGaming industry.&nbsp;</span></p>
</li>
<li >
<p ><span>Offer only top-notch games. This will build customer satisfaction resulting in their trust and loyalty.</span></p>
</li>
<li >
<p ><span>Appoint content writers in your marketing team to create effective articles or blogs, e.g. help guides for gamers on your website.</span></p>
</li>
<li >
<p ><span>Make your content optimally SEO friendly, if you want your website to be conveniently searchable.&nbsp;</span></p>
</li>
<li >
<p ><span>Run a Google Adwords Campaign to bring more visitors to your website.</span><span><br /><br /></span></p>
</li>
</ul>
<p><span><span><br /><br /></span></span></p>
<p ><span>The fire in your business would be sparkled by an efficient marketing campaign. Its key purpose is to encourage your target audience to visit your website and become your players. Your operation should remain successful in the competitive market, or other firms like yours with better marketing plans will come to be the ones on top. You should avoid this at the earliest opportunity.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>If you want to be profitable, come up with first-rate marketing ideas. This takes a lot of research. You just need a complete view of the gaming industry as a whole. Understand who the leaders are, what strategies they employ and what kinds of returns they get on their investments. Knowing the market could allow you to develop a platform that players wouldn&rsquo;t be able to turn away from. You might have to reach out to SEO agencies, email marketing firms and media-buying services in this process.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Then there is </span><span>affiliate marketing. </span><span>It is especially useful for online casinos or sports betting sites.&nbsp; You pay a share of your revenue to affiliate websites and individuals that bring traffic to you and agree to some exposure.&nbsp; There are plenty of affiliate sites out there with loads of website traffic they could redirect your way. Just browse around and pick one that meets your needs. Developing and establishing your own affiliate network is not a bad idea, either. That will help you build the connections you need to get your name out there by cultivating long-lasting relationships.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>All of this requires marketing specialists by your side to deal with such issues and promote your operation as a legal unrestricted one. This primarily suggests carefully following applicable terms and conditions. In the case of BetConstruct, our experts can support you with professional advice. Our experienced marketing team is always ready to offer promotional materials, useful samples, welcome bonus strategies, etc.&nbsp;</span></p>
<p><span><span><br /><br /><br /></span></span></p>
<p ><span>CHOOSING THE MARKET</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Before starting your iGaming business, research your potential market. Collect information about the target audience of your brand, the trends they follow, their activity habits, motivations and aspirations. Figure out what they want from an iGaming site and take a peek at your competitors to see what is already offered.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Identify your consumer habits, effective advertising strategies, competitors and their successful business approaches. Analysis will allow you to identify the trends and possible barriers affecting your business management in the long run. Get the full details about your players, understand what stimulates them to take action.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Online gaming and sports betting have been allowed in many countries, but there are also those where these types of gaming are illegal. Difficulties with laws do exist. The primary problem is that the laws are set on a regional basis, and what is lawful in one country may not be legal in another.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>To avoid miscalculation, understand which market you&rsquo;ll be focusing on. This can help you</span></p>
<ul>
<li >
<p ><span>Focus on the priority of specific products and tools;</span></p>
</li>
<li >
<p ><span>Find out what it takes for your website to look great;</span></p>
</li>
<li >
<p ><span>Set the languages that must be available,&nbsp;</span></p>
</li>
<li >
<p ><span>Decide what currencies you'll be providing,&nbsp;</span></p>
</li>
<li >
<p ><span>Choose payment methods you&rsquo;ll support&nbsp;</span></p>
</li>
</ul>
<p><span><span><br /><br /><br /></span></span></p>
<p ><span>&nbsp;</span></p>
<p ><span>GET A GREAT TEAM</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Having a great team is another strength you need to have. Since iGaming is a very specific area, customers are going to ask many questions, present their numerous queries, and address their multiple issues to you. So you need to have a well-prepared </span><span>customer service team</span><span> to face that all. Alternatively, you can always charge BetConstruct specialists with that responsibility. We provide multilingual professional customer support you can take advantage of.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Any operator needs professionals responsible for their products, because every product has its own logic and requires a dedicated manager. The more products you have, the higher the risk is and the bigger the</span><span> risk management team</span><span> should be.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>On top of that, you need a very responsible</span><span> marketing team</span><span> for the extensive promotion of your operation.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>If you have a Sportsbook, a team of trader</span><span>s </span><span>is another necessity, since every market has its specific coefficient mentality. E.g. in Asia people bet more on risky coefficients compared to the UK. So there&rsquo;s a need for a</span><span> trading team </span><span>to understand the specifics, difficulties and issues of certain markets. Fortunately, all these services are included in the package offered by BetConstruct.</span></p>
<p><span><span><br /><br /><br /></span></span></p>
<p ><span>MANAGE RISKS</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>It is essential to identify good customers right at the very beginning. This will help you correctly tackle and encourage the good ones to serve for the benefit of your operation. On the other hand, you will learn to avoid the bad ones who may cause harm to your business and reputation.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Most software providers&rsquo; services include risk management solutions. In BetConstruct&rsquo;s case, we offer our very own </span><a href="https://console.betconstruct.com/tools/umbrella"><span>Umbrella</span></a><span> - an automated AI-based risk management tool you may want to consider using to fully protect your iGaming business. Read more about Umbrella </span><a href="https://help.betconstruct.com/en/articles/4261581-umbrella"><span>here</span></a><span>.</span></p>
<p><span><span><br /><br /><br /></span></span></p>
<h2 ><span>CHOOSE PAYMENT SYSTEM PROVIDER</span></h2>
<p><span><span>&nbsp;
<img src=${require('../assets/imgs/innerIcons/ChoosePaymentSystem.png').default} width="689" alt="">
</span></span></p>
<p ><span>All iGaming sites require a payment system that players will trust with their financial details. The payment mechanism must be safe, swift and efficient. Find a provider with a strong track record and one that provides players with various payment methods. This is a must when launching an online casino venture.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Does the payment system offer fraud detection options? Does it support multiple currencies? Can it be integrated with your site? Does it provide guaranteed security for all payment details and sensitive information to protect your players and your business? Will your gaming website include a strong defense system with firewalls and other safety measures?</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Choosing your payment system provider is very important in terms of avoiding fraud that can destroy your operation&rsquo;s reputation. Partner with a provider that has built its credibility in the iGaming sector; one that offers safe payment, multi-currency transactions and fraud detection.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>In addition, review alternative payment options that your target audience may want to use. Not all are comfortable paying with their credit cards. Today, there are various other payment methods, such as wire transfers, cryptocurrency, e-checks and e-wallets. Accepting other payment methods will improve your operation&rsquo;s chance to get more players.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>With BetConstruct, our turnkey partners have an opportunity to select and enable any payment method from our 500+ extensive list. You can set up any of the existing payment methods.</span></p>
<p><span><span><br /><br /></span></span></p>
<p ><span>CHOOSE YOUR GAMING CONTENT</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Different types of gaming are popular in different jurisdictions. Offer the games that suit your target audience. Maybe you can offer more games as your business grows. The classic games, like slot games, are most popular but you should also include the latest trends for players who want to try something new and different.</span></p>
<h4 ><span>Decide what you actually want to offer to your customers. What software platform will you be using on your website? Apart from offering popular casino games like slots, blackjack, baccarat, bingo or poker, also add some additional features, such as a bonus creation option, a real-time chat room, etc.</span></h4>
<p><span><span><br /><br /></span></span></p>
<p ><span>HAVE A GOOD DOMAIN NAME AND WEBSITE DESIGN</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>The name and appearance of your iGaming platform need to be attractive. The website name must be catchy and easy to recall. The layout should appeal to your target audience. Your banners are supposed to immediately draw players in. Sign-up should be straightforward. Bonuses, promotions, jackpots and loyalty programmes must be seen at a glance. Your website needs to be clean, with no extra graphics slowing down the loading time and making the player-experience less than friendly.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Make your website different from others. It should represent the quality of your business and help players trust your operation.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Here are some additional factors to consider when creating a website:</span></p>
<ul>
<li >
<p ><span>Optimise your website for mobile users</span></p>
</li>
<li >
<p ><span>Players use different browsers; so, your website has to be compatible with all the available browsers, especially the popular ones as it will result in attracting more audiences.</span></p>
</li>
<li >
<p ><span>Always update and secure your website to avoid spam.</span></p>
</li>
<li >
<p ><span>Check dead or orphan links to avoid frustration from players. Either update them or delete them, depending on their level of importance.</span></p>
</li>
<li >
<p ><span>Make sure that your website is SEO-friendly for your business to get high traffic.&nbsp;</span></p>
</li>
</ul>
<p><span><span><br /><br /></span></span></p>
<p ><span>SET YOUR BUDGET</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>It is best to set a budget that will at least cover the first year or two of operation. Avoid setting your budget after the operation has already been launched. Do that in advance, so you will know all the expenses involved. You don&rsquo;t want any unforeseen costs to occur within the first year of your operation.</span></p>
<p><span><span><br /><br /><br /><br /><br /><br /><br /></span></span></p>
<p ><span>CONCLUSION</span></p>
<p><span><span><br /><br /></span></span></p>
<p ><span>There is tremendous demand for the gambling industry, but building an online gaming business requires a great deal of work.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Starting an iGaming business is not something that you can simply do overnight. In order to be truly successful in your endeavor, you are going to need to start a gaming business that benefits you as an owner and brings pleasure to your players.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>In order to achieve success, you will need to&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>have a keen eye for details and an in-depth understanding of marketing;</span></p>
</li>
<li >
<p ><span>collect enough information;</span></p>
</li>
<li >
<p ><span>be creative;</span></p>
</li>
<li >
<p ><span>understand your audience;</span></p>
</li>
<li >
<p ><span>leave room for growth;</span></p>
</li>
<li >
<p ><span>be patient and persistent.</span></p>
</li>
</ul>`,
  },
  {
    name: 'Choosing a Software Provider',
    slug: 'softwareProvider',
    icon: '',
    path: 'business-operations/software-provider',
    shortDescription: 'All about finding the right iGaming software provider for your operation.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/ChoosingSoftwareProvider.png').default} width="689" alt="">
</div>
<br>
<p ><span>Choosing the right iGaming software provider is one of the most important decisions to make as an online gaming operator. Pick a wrong iGaming platform - and you could be flushing valuable resources down the drain and losing a considerable number of players. You&rsquo;re entering a long-term partnership with your iGaming software provider, so the decision you make can&rsquo;t be poor.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Of course, your skilled in-house team could develop the software, and that&rsquo;s a brave idea. But the best solution would be to find an iGaming software provider with the right tool sets and prerequisites. When choosing a provider, it is best to select one that offers quality software at a price that matches your budget.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>In the process of finding a suitable software provider, it&rsquo;s important to know which features to look for and what you want to achieve. This will help you select the best option that meets your overall requirements.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Here are some suggestions.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Determine your iGaming business requirements</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Do you need</span></p>
</li>
<ul>
<li >
<p ><span>a white label solution</span></p>
</li>
<li >
<p ><span>or a turnkey solution?</span></p>
</li>
</ul>
<li >
<p ><span>Do you wish to&nbsp;</span></p>
</li>
<ul>
<li >
<p ><span>be able to run a ready-to-use successful sports betting and casino service&nbsp;</span></p>
</li>
<li >
<p ><span>or quickly and easily integrate the software into your existing systems?</span></p>
</li>
</ul>
<li >
<p ><span>Do you wish to&nbsp;</span></p>
</li>
<ul>
<li >
<p ><span>operate with your own gaming licence&nbsp;</span></p>
</li>
<li >
<p ><span>or find an iGaming software provider that provides one?</span></p>
</li>
</ul>
<li >
<p ><span>Do you want to&nbsp;</span></p>
</li>
<ul>
<li >
<p ><span>use your own CMS</span></p>
</li>
<li >
<p ><span>or integrate an existing CMS?</span></p>
</li>
</ul>
</ul>
<p ><span>&nbsp;</span></p>
<p ><span><span><br /><br /></span></span></p>
<ol start="2">
<li >
<p ><span>Find a fully customisable solution</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The success of your online gaming business largely depends on how customisable the software system is. You&rsquo;ll definitely want flexibility in creating a sports betting and casino website that matches your business requirements and allows you to swiftly adapt to the fast-changing iGaming industry. So look for flexible solutions with a wide selection of options, games and features.</span></p>
<p ><span>&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Check the reputation</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Search for a respectable iGaming software provider with an already established reputation and a solid client base. You can request feedback from the provider&rsquo;s operators to find out if the software solutions are up to their expectations.</span></p>
<p ><span>&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Check the background</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Do some research and evaluation of different iGaming software providers. Take a closer look at their credentials, business history and licences. Have they been growing or downsizing? Do they have qualified professionals to ensure high-quality and high-performance services? Have they got the necessary maturity and understanding of the iGaming industry to take your operation to the next level?</span></p>
<p ><span>&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Look for unique, competitive features</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Find an iGaming solution that has a competitive edge and special features. If what the software provider offers is unique, you&rsquo;ll have higher chances to set yourself apart from the competition.</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>A good software developer is usually characterised by:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Cross-platform products</span></p>
</li>
<li >
<p ><span>A wide selection of games</span></p>
</li>
<li >
<p ><span>High quality of games</span></p>
</li>
<li >
<p ><span>Convenient user interface</span></p>
</li>
<li >
<p ><span>Realistic graphics</span></p>
</li>
<li >
<p ><span>Availability of licences and certificates</span></p>
</li>
<li >
<p ><span>A gaming management system</span></p>
</li>
<li >
<p ><span>Premium quality back-end tools</span></p>
</li>
<li >
<p ><span>Payment gateways that have a multi-currency support</span></p>
</li>
<li >
<p ><span>An easy-to-navigate front-end</span></p>
</li>
<li >
<p ><span>Access to well-known online games and events</span></p>
</li>
<li >
<p ><span>Great customer support</span></p>
</li>
</ul>
<p ><span><span><br /><br /></span></span></p>
<p ><span>Why the right iGaming software provider matters? Mostly because picking a trustworthy iGaming software provider is the key to entering the online gaming industry. A provider offering high quality in all details, smooth functionality, secure payment systems and so much more, all of which eventually lead to greatly enjoyable player experience and effective business growth.</span></p>
<p ><span>&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Choose a software provider with an optimally safe, flexible and customisable iGaming platform that will become the heart of your operation. The success and growth of your business will greatly depend on the capacity of that platform.&nbsp;</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>Aim for a top provider that offers a wide variety of cutting-edge gaming and betting solutions: Sportsbook, Casino, Live Casino, VR Casino, Skill games, to name a few.</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>Let your software provider be one with powerful ML-driven CRM tools for effective player acquisition and retention, alongside modern AI-powered real-time risk management solutions. On top of that, a trustworthy iGaming software provider is the one with an exceptional B2B/B2C&nbsp; support package - 24/7, real-time, multichannel and multilingual.&nbsp;&nbsp;</span></p>
<p ><span>&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>In fact, you can opt for different iGaming software providers for each stage separately. For starters, you could look into BetConstruct, an award-winning gaming and betting software provider with numerous innovative solutions for your iGaming business. We stand out with our top-quality games, ever-increasing number of players and sustainable income. You can even create a free trial iGaming website via BetConstruct&rsquo;s </span><a href="https://console.betconstruct.com/"><span>SpringBME console</span></a><span>. Give us a try.</span></p>`,
  },
  {
    name: 'Choosing a Market',
    slug: 'market',
    icon: '',
    path: 'business-operations/market',
    shortDescription: 'The ultimate advice on researching your' +
      ' potential iGaming business market and picking up the right target audience for your brand\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/ChoosingMarket.png').default} width="689" alt="">
</div>
<br>
<p ><span>Before starting your iGaming business, research your potential market. Collect information about the target audience of your brand, the trends they follow, their activity habits, motivations and aspirations. Figure out what they want from an iGaming site and take a peek at your competitors to see what is already offered.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Identify your consumer habits, effective advertising strategies, competitors and their successful business approaches. Analysis will allow you to identify the trends and possible barriers affecting your business management in the long run. Get the full details about your players, understand what stimulates them to take action.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Online gaming and sports betting have been allowed in many countries, but there are also those where these types of gaming are illegal. Difficulties with laws do exist. The primary problem is that the laws are set on a regional basis, and what is lawful in one country may not be legal in another.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>To avoid miscalculation, understand which market you&rsquo;ll be focusing on. This can help you</span></p>
<ul>
<li >
<p ><span>Focus on the priority of specific products and tools;</span></p>
</li>
<li >
<p ><span>Find out what it takes for your website to look great;</span></p>
</li>
<li >
<p ><span>Set the languages that must be available,&nbsp;</span></p>
</li>
<li >
<p ><span>Decide what currencies you'll be providing,&nbsp;</span></p>
</li>
<li >
<p ><span>Choose payment methods you&rsquo;ll support&nbsp;</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>When choosing a market, check the level of its overall busyness. Some markets are complex and expensive. You need a hard-working team to supervise the legitimacy of your operation. Then, there are taxes. E.g. casinos operating under the Curacao licence pay lower taxes than casinos and websites based on some strict jurisdictions. Say, in England, the competition is very strong: to start an operation in the UK, you may need a 100 times bigger budget than you would for the same procedure in Kazakhstan. Decide for yourself - whether or not you can afford a licence for that specific territory country.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Extensive research is important for understanding the market. It will help you identify your target market, consumer habits, advertising strategies, competitors and their successful business approaches. Through analysis, you will be able to identify the trends and stumbling blocks affecting your management of the business in the long run.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Conducting market research also involves collecting data about your business&rsquo;s target audience and players&rsquo; demographics, behaviour patterns, motivations, and goals. Having the complete details about your prospects and players will lead your iGaming business to figure out what stimulates them to take action.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Here are some types of market research:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Exploratory Research is about discovering company problems, areas for potential growth, and alternative courses of action through open-ended interviews or surveys to learn more about the people you are surveying.</span></p>
</li>
<li >
<p ><span>Specific Research is the next step to be taken after the exploratory research, and it aims to address the previously identified issues or opportunities by interviewing a specific portion of the target audience.</span></p>
</li>
<li >
<p ><span>Public Sources are the free available sources such as government statistics or public market data that you can read to help you with analysing your competitors.&nbsp;</span></p>
</li>
<li >
<p ><span>Commercial Sources have priced market reports that will give you industry insights.</span></p>
</li>
<li >
<p ><span>Internal Sources are the historical data that your business organisation possesses to help you figure out the needs and wants of your core audience.&nbsp;</span></p>
</li>
</ul>`,
  },
  {
    name: 'Choosing a Licence',
    slug: 'licence',
    icon: '',
    path: 'business-operations/licence',
    shortDescription: 'How to be considered a trustworthy, responsible' +
      ' iGaming operator and carry out your online gambling operations' +
      ' on a legal basis, with a proper iGaming licence. \n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/ChoosingLicence.png').default} width="689" alt="">
</div>
<br>
<p ><span>An iGaming licence is an indicator of the high-level transparency and security of an online gaming and betting website. Licences are issued by the licensing authority of the region you want to operate in. The regions are referred to as online gambling jurisdictions or licensing jurisdictions. They have different sets of law-based requirements that make issuing a gambling licence possible.&nbsp;&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>To be considered a trustworthy and responsible iGaming operator, you must carry out your online gambling operations on a legal basis. This means obtaining a gaming and betting licence from the jurisdiction you plan to set up your iGaming business in. Considering your location is one of the primary aspects.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Getting a licence from a reputable jurisdiction can be a time-consuming and costly process. To receive a valid iGaming licence, you will need to prove to the concerned authorities that you stick to all the conditions. It normally requires a lot of due diligence and research.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>It is often recommended to get </span><span>a lawyer</span><span> with experience in the iGaming industry. Establishing an online-operating company comes with various legal requirements. There may be many rules and regulations for the gaming industry. Before launching your iGaming operation, find out the necessary licences that are required in your jurisdiction, because your operation cannot legally operate without them.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Some iGaming licences cover all forms of gaming while other jurisdictions require having different licences for each type of gaming. Go for a gaming licence from a jurisdiction with friendly tax laws; where the licence fees are reasonable and where the licence is accepted in a wide range of countries.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>In general, the gaming industry has 4 different jurisdiction categories:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>countries that control iGaming within their area</span></p>
</li>
<li >
<p ><span>countries that have banned iGaming</span></p>
</li>
<li >
<p ><span>countries that have monopolies</span></p>
</li>
<li >
<p ><span>countries that have no set of rules</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>There is always the alternative of trying trustworthy B2B suppliers or software providers for a licence to initiate your iGaming operations. They will cover all legal and regulatory aspects while also providing a payment gateway, games, and management tools.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct fits that option, as it offers a bunch of licences and certificates for its partners to operate with.&nbsp;</span></p>
<ol>
<li >
<p ><span>Choosing to work with the software provider&rsquo;s licence will mean going for the</span><span>white label</span><span> option. With BetConstruct, the white label offering includes betting and gaming products under our licences of Cura&ccedil;ao, Malta, UK, ONJN, France, etc.</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Operating with your own licence will imply going for the </span><span>turnkey </span><span>option. But even in this scenario, BetConstruct helps its turnkey partners obtain a licence.</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The type of a gambling licence you need depends on such factors as the category of gaming and betting (online poker, slots, sportsbook, etc.), the jurisdiction you and/or your players are based on, operating currencies and so on. For example, let's take a </span><span>look at 5 gambling licences, their costs, ongoing compliances and obtaining procedures.</span></p>
<p ><span>&nbsp;</span></p>
<p ><span>Jurisdiction: UK Gambling Commission</span></p>
<p ><span>Authorises for Great Britain.</span></p>
<p ><span>Takes 16 weeks.</span></p>
<p ><span>Covers arcades, betting, bingo, casinos, gaming machine providers, gambling software providers, lottery operators, external lottery managers and remote gambling (online and by phone).</span></p>
<p ><span>- High international reputation</span></p>
<p ><span>- Expensive operations</span></p>
<p ><span>- Transparency of business</span></p>
<p ><span>- Protection of vulnerable persons</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>Jurisdiction: Cura&ccedil;ao e&ndash;Gaming&nbsp;</span></p>
<p ><span>Authorises for any country where gambling is not legally prohibited.</span></p>
<p ><span>Not applicable in Curacao, France, The Netherlands, Australia, USA.</span></p>
<p ><span>Takes 2-4 weeks</span></p>
<p ><span>Covers casino games, sports betting, lotteries, poker and bingo</span></p>
<p ><span>- One licence covering all activities</span></p>
<p ><span>- Easy licence-obtaining process</span></p>
<p ><span>- No VAT, low-profit tax rate</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Jurisdiction: Malta Gaming&nbsp;</span></p>
<p ><span>Authorises for the EU</span></p>
<p ><span>Takes 12-16 weeks</span></p>
<p ><span>Covers Casino, eSport, Poker, Sports Betting, Lotto, Bingo, Bitcoin Casino, Fantasy Sports, Games of Skill</span></p>
<p ><span>- Secure business environment</span></p>
<p ><span>- Medium operation cost</span></p>
<p ><span>- Separate licenses for various gambling activities</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Jurisdiction: Isle of Man Gambling</span></p>
<p ><span>Authorises for the Isle of Man</span></p>
<p ><span>Takes 10-12 weeks</span></p>
<p ><span>Covers land-based gambling operations, online gambling activities</span></p>
<p ><span>- Fully committed to player protection, especially youth</span></p>
<p ><span>- Low tax rates</span></p>
<p ><span>- Software is inspected by trustworthy companies</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Jurisdiction: Gibraltar Gambling&nbsp;</span></p>
<p ><span>Authorises for the UK</span></p>
<p ><span>Takes 3-6 months</span></p>
<p ><span>Covers poker, bingo, betting and online casino websites, land-based gambling operations</span></p>
<p ><span>- High-class jurisdiction</span></p>
<p ><span>- Law taxes</span></p>
<p ><span>- Effective software testing system</span></p>
<p ><span>- Dispute management</span></p>
<p ><span><br /></span><span>It needs to be mentioned that BetConstruct has a lot of other market-specific jurisdictions that our legal &amp; licensing department can help to choose and obtain.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>&nbsp;</span></p>`,
  },
  {
    name: 'Promoting Your iGaming Operation / Player Acquisition and Retention',
    slug: 'acquisitionAndRetention',
    icon: '',
    path: 'business-operations/acquisition-and-retention',
    shortDescription: 'The promotion of your iGaming operation' +
      ' is directly or indirectly related to player' +
      ' acquisition and retention. Learn more.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/PromotingYouriGamingoperations.png').default} width="689" alt="">
</div>
<br>
<p ><span>Once you&rsquo;ve started, you will need to promote your iGaming operation in every possible way. Highlight the strongest features of your business to sell your product to prospective players. Come up with unique offers in the form of captivating games, free bets, bonuses, etc. Whatever your strengths are, specify them and spread the word.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Promoting an iGaming operation can get a bit pricey depending on which medium you decide to use.&nbsp; Facebook advertisement, for example, can be a bit tricky: you agree to a minimum spend and submit an application to be approved for advertising online gambling.&nbsp; With PPC campaigns, the cost per click for online gaming is greater than what you can expect with most companies. This doesn&rsquo;t actually need to be a negative; it simply means you have to make sure you spend your money carefully and track your return on investment on an ongoing basis to see which platforms are working for you.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The iGaming advertising market has its specifics and nuances. For instance, there are many social media restrictions. Also, Google frequently blocks most operations. You will need an outstanding marketing strategy for social media marketing, gambling forums, articles, blogs and online advertising using search words and SEO. Good marketing campaigns call for generous investments but require meticulous preparation, hard work and luck.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Additionally, the conversion rate in iGaming business is quite low, while the cost-per-acquisition is rather high. In other words, it costs a lot to pull a player out of their favourite online gaming platform: they either need to get disappointed in that provider or your offers have to be really outstanding. Apart from visible outward advertising, it&rsquo;s actually your business&rsquo;s internal offers that can do the best promotion for your operation: this includes your bonuses, jackpots, free rolls, free spins, etc. In your advertising, you need to be more appealing than your opponents.</span></p>
<h4 ><span>So how can your business stand out from the rest?</span></h4>
<ul>
<li >
<p ><span>Form a marketing team with a deep experience in the iGaming industry.&nbsp;</span></p>
</li>
<li >
<p ><span>Offer only top-notch games. This will build customer satisfaction resulting in their trust and loyalty.</span></p>
</li>
<li >
<p ><span>Appoint content writers in your marketing team to create effective articles or blogs, e.g. help guides for gamers on your website.</span></p>
</li>
<li >
<p ><span>Make your content optimally SEO friendly, if you want your website to be conveniently searchable.&nbsp;</span></p>
</li>
<li >
<p ><span>Run a Google Adwords Campaign to bring more visitors to your website.</span><span><br /><br /></span></p>
</li>
</ul>
<p ><span>The fire in your business would be sparkled by an efficient marketing campaign. Its key purpose is to encourage your target audience to visit your website and become your players. Your operation should remain successful in the competitive market, or other firms like yours with better marketing plans will come to be the ones on top. You should avoid this at the earliest opportunity.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>If you want to be profitable, come up with first-rate marketing ideas. This takes a lot of research. You just need a complete view of the gaming industry as a whole. Understand who the leaders are, what strategies they employ and what kinds of returns they get on their investments. Knowing the market could allow you to develop a platform that players wouldn&rsquo;t be able to turn away from.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>After completing primary requirements to start your business, you have to prepare your marketing strategies in terms of advertising and promotion.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The promotion of your operation is directly or indirectly related to player acquisition and retention. Players won&rsquo;t come to your website right after you establish your online presence. You need to take specific steps to draw players to your website and keep them engaged. You can bait your players with bonuses, jackpots, big-prized tournaments. Then there are ML-driven Customer Relationship Management tools for effective player retention. Advanced customer relationship management tools can help gaming operators to better understand players&rsquo; needs, offer them what they want, reduce the churn rate, refine player segmentation for targeted markets and so on.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>As an iGaming business marketer, you must know how important it is to reach your potential players by all possible digital means. Digital advertising networks serve as mediators between advertisers, i.e. the online gambling website and the publisher website on which your gambling ad will be displayed. They can help iGaming operators coordinate an ad campaign across thousands of publisher websites efficiently.&nbsp;&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<h5 ><span>In this era of technological transformation, innovative digital player acquisition strategies outpace the traditional ones. The battle for players&rsquo; attention is now happening on online platforms, with digital weaponry. Online casino and sportsbook owners need to establish a solid online presence in order to engage with potential players at every touchpoint.</span></h5>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Digital advertising networks generally work with the following pricing options:</span></p>
<p ><span>&nbsp;</span></p>
<ul>
<li >
<p ><span>Cost-per-mile (CPM): This is the price that an advertiser pays for one thousand views of their ad.</span></p>
</li>
<li >
<p ><span>Cost-per-click (CPC): An online advertising model in which an advertiser pays when the ad is clicked.</span></p>
</li>
<li >
<p ><span>Cost-per-acquisition (CPA): The pricing model suggests that the advertiser pays for a specified acquisition.</span></p>
</li>
<li >
<p ><span>Cost-per-view for video (CPV): The payout is triggered each time the video ad is viewed. Most ad networks count 30 seconds as a video view when charging for&nbsp; CPV.</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The list of well-known, secure and reputable advertising networks in the iGaming industry includes such names as</span></p>
<p ><a href="https://adboosters.com/?lang=en"><span>1. AdBoosters.com&nbsp;</span></a></p>
<p ><a href="https://www.taboola.com/"><span>2. Taboola.com</span></a></p>
<p ><a href="https://www.bidvertiser.com/"><span>3. Bidvertiser.com&nbsp;</span></a></p>
<p ><span>Digital ad networks like these can boost your success in player acquisition.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>A good online player acquisition strategy is the driving force behind every successful iGaming business. Of course, offline activities do play a large role in directing the player flow to your gaming and betting business. Yet, in this digital era, online player acquisition strategies prove to be more efficient. Well-planned affiliate marketing, search engine optimisation (SEO), paid search marketing, social network marketing and digital media ads are all the solid bricks that form the baseline of an effective player acquisition strategy.&nbsp;</span></p>
<p ><span>&nbsp;</span></p>
<p ><span>Affiliate Marketing</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Affiliates promote your gambling website in return for a revenue share. They get a certain commission percentage from the partner, based on players&rsquo; actions, i.e. cost-per-action approach is applicable in affiliate marketing. Alternatively, affiliates can receive commission based on&nbsp; players&rsquo; losses: this is known as a cost-per-sale approach. In a nutshell, affiliate marketing is a performance-based marketing strategy. The more players affiliates direct to your website, the higher their share will be.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<h5 ><span>SEO for Sportsbook and Online Casinos</span></h5>
<h5 ><span>Optimising your iGaming website&rsquo;s content for the search engines will help you stay at the top of search pages and be quickly found by players. Having a blog on your website that covers industry-related topics can be a real SEO-booster. It helps to build trust with potential players and adds credibility to your website. Blogs increase your chances to beat out your competitors on the search engine results page. Quality content in your blog, enriched with relevant keywords, is a significant factor for Google (or other search engines) in the process of assessing your website.</span></h5>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>&nbsp;</span></p>
<p ><span>Paid Search Marketing</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>PPC and CPC are highly valuable online ad methods that ensure steady player traffic into a sportsbook or casino website. These are targeted, fast, easily trackable and provide high-level website exposure.&nbsp;&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<h4 ><span>Social Networks</span></h4>
<h5 ><span>Social networks are another channel online gaming websites use to acquire new players. These greatly contribute to the recognition of your brand. Regularly posting some engaging iGaming-related content with powerful CTAs on your social media pages will motivate players to take action, i.e. place bets or play.</span></h5>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Digital Advertising Networks</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Digital advertising networks serve as mediators between the advertiser, i.e. the iGaming website, and the publisher, i.e. the website on which your gambling ad is to be displayed. They can help igaming operators coordinate ad campaigns across thousands of publisher websites in a very efficient manner. They use their big inventory of gambling networks to take your ads to the right people.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<h5 ><span>In this era of technological transformation, innovative digital player acquisition strategies outpace the traditional ones. The battle for players&rsquo; attention is now happening on online platforms, with digital weaponry. Online casino and sportsbook owners need to establish a solid online presence in order to engage with potential players at every touchpoint.</span></h5>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>All of the aforesaid requires marketing specialists by your side to deal with these issues and promote your operation as a legal unrestricted one. This primarily suggests carefully following applicable terms and conditions. In the case of BetConstruct, our experts can support you with professional advice. Our experienced marketing team is always ready to offer promotional materials, useful samples, welcome bonus strategies, etc. Feel free to contact us.</span></p>
<p><span>&nbsp;</span></p>`,
  },
  {
    name: 'Managing Risks',
    slug: 'risks',
    icon: '',
    path: 'business-operations/risks',
    shortDescription: 'AI-powered and ML-based real-time ' +
      'risk management systems are an important factor ' +
      'to take into account when choosing an iGaming ' +
      'software provider. Learn more.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/ManagingRisks.png').default} width="689" alt="">
</div>
<br>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>It is essential to identify good players right at the very beginning. This will help you correctly tackle and encourage the good ones to serve for the benefit of your operation. On the other hand, you will learn to avoid the bad ones who may cause harm to your business and reputation.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Across the entire history, cheaters, fraudsters, bonus hunters, multiple account players, late bettors have been going hand in hand with online gaming. You may have hundreds of thousands of players on your platform, but risky ones are often the reason you still struggle to pursue sustainable profit growth. Numerous players are in constant search of ways to take advantage of odds imperfections, system loopholes and delays. It is therefore important to safeguard the gaming company from fraudulent activities. In such situations, an inch of incorrectness and a few seconds of a slowdown can cause substantial losses to an online gaming business.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>In view of this, an AI-powered real-time risk management system is an important factor to take into account when choosing an iGaming software provider. Modern ML-based risk management tools make it possible for gaming operators to promote responsible gaming, instantly detecting and managing risky players. This way, any fraudulent activity is identified and eliminated before it occurs.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The risk management process consists of 4 stages:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Stage 1: Verification - identifying customers through personal data (KYC, CDD / ECDD, SOF and SOW checks, Responsible gambling checks, Reporting).</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Stage 2: Sportsbook (clients risk analytics) - ensuring that sportsbook clients base is optimised to reduce the negative outcome and increase the profitability of the business.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Stage 3: Casino (clients risk analytics casino) - checking the game style, types of games and bets, submitting daily/weekly/monthly/annual reports if needed.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Stage 4: AML stage - AML checks are carried out in real time to build a clean customer base.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Any iGaming operator will confirm that a robust risk management system is an essential part of every online betting and gaming business. You may have the most functional and game-rich sports betting or casino platform and yet eventually be left with a negative ROI.&nbsp;</span></p>
<p ><span>&nbsp;</span></p>
<p ><span>The bottom-line three components of a top-quality risk management system are:&nbsp;&nbsp;</span></p>
<ul>
<li >
<p ><span>innovative sophisticated risk management tools,&nbsp;&nbsp;</span></p>
</li>
<li >
<p ><span>accurate mathematical algorithms,</span></p>
</li>
<li >
<p ><span>a team of expert risk managers.&nbsp;&nbsp;</span></p>
</li>
</ul>
<p ><span>&nbsp;</span></p>
<p ><span>The implementation of artificial intelligence in the online gambling industry includes, but is not limited to:</span></p>
<p ><span>&nbsp;</span></p>
<ul>
<li >
<p ><span>collecting high-quality data,&nbsp;&nbsp;</span></p>
</li>
<li >
<p ><span>analysing player gaming and betting habits,&nbsp;&nbsp;</span></p>
</li>
<li >
<p ><span>tailoring offers to every player&rsquo;s needs,&nbsp;&nbsp;</span></p>
</li>
<li >
<p ><span>personalising user experience: giving recommendations on bet markets and casino games,</span></p>
</li>
<li >
<p ><span>detecting and preventing illegal gaming and betting activities in advance.</span></p>
</li>
</ul>
<ul>
<li >
<p ><span>comprehensive analysis of the entire lifecycle of players,</span></p>
</li>
<li >
<p ><span>automated and semi-automated player segmentation,</span></p>
</li>
<li >
<p ><span>real-time detection of risky behavior with corresponding alert notifications,</span></p>
</li>
<li >
<p ><span>instant application of restraining measures based on the player&rsquo;s betting behavior.</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Automated and semi-automated risk management tools are largely used at every stage of risk management, preventing the malicious activity of players and mitigating risks of loss. The involvement of AI-powered software in the risk management process can be presented like this:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Registration</span></p>
<ul>
<li >
<p ><span>Potential Risks</span></p>
</li>
<ul>
<li >
<p ><span>Multi-account</span></p>
</li>
<li >
<p ><span>Account sharing</span></p>
</li>
<li >
<p ><span>Fake account</span></p>
</li>
<li >
<p ><span>Bonus abuse</span></p>
</li>
</ul>
<li >
<p ><span>Risk Management Measures</span></p>
</li>
<ul>
<li >
<p ><span>ID verification</span></p>
</li>
<li >
<p ><span>Device fingerprinting</span></p>
</li>
<li >
<p ><span>Cookie scanning</span></p>
</li>
<li >
<p ><span>IP analysis (MAC address analysis)</span></p>
</li>
<li >
<p ><span>PEP checks</span></p>
</li>
<li >
<p ><span>ML/FT risk assessment</span></p>
</li>
<li >
<p ><span>Document validation</span></p>
</li>
<li >
<p ><span>Player segmentation</span></p>
</li>
</ul>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Log in</span></p>
<ul>
<li >
<p ><span>Potential Risks</span></p>
</li>
<ul>
<li >
<p ><span>Account takeover</span></p>
</li>
<li >
<p ><span>Compromised account</span></p>
</li>
</ul>
<li >
<p ><span>Risk Management Measures</span></p>
</li>
<ul>
<li >
<p ><span>ID verification</span></p>
</li>
<li >
<p ><span>2-factor authentication</span></p>
</li>
<li >
<p ><span>Behavioural analysis</span></p>
</li>
<li >
<p ><span>IP analysis (MAC address analysis)</span></p>
</li>
<li >
<p ><span>Email analysis</span></p>
</li>
<li >
<p ><span>Device fingerprinting</span></p>
</li>
</ul>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Deposit</span></p>
<ul>
<li >
<p ><span>Potential Risks</span></p>
</li>
<ul>
<li >
<p ><span>Money laundering</span></p>
</li>
<li >
<p ><span>Identity theft</span></p>
</li>
<li >
<p ><span>Friendly fraud</span></p>
</li>
</ul>
<li >
<p ><span>Risk Management Measures</span></p>
</li>
<ul>
<li >
<p ><span>ID verification</span></p>
</li>
<li >
<p ><span>Behavioural analysis</span></p>
</li>
<li >
<p ><span>IP analysis (MAC address analysis)</span></p>
</li>
<li >
<p ><span>Limit setting</span></p>
</li>
<li >
<p ><span>Player categorisation</span></p>
</li>
</ul>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Gaming and Betting Activity</span></p>
<ul>
<li >
<p ><span>Potential Risks</span></p>
</li>
<ul>
<li >
<p ><span>Collusion</span></p>
</li>
<li >
<p ><span>Chip dumping (Poker)</span></p>
</li>
<li >
<p ><span>Late betting</span></p>
</li>
<li >
<p ><span>Arbitrage betting</span></p>
</li>
<li >
<p ><span>Bonus abuse</span></p>
</li>
</ul>
<li >
<p ><span>Risk Management Measures</span></p>
</li>
<ul>
<li >
<p ><span>ID verification</span></p>
</li>
<li >
<p ><span>Behavioural analysis</span></p>
</li>
<li >
<p ><span>Player categorisation</span></p>
</li>
<li >
<p ><span>Gamestyle detection</span></p>
</li>
<li >
<p ><span>Setting limits</span></p>
</li>
<li >
<p ><span>Setting delays</span></p>
</li>
<li >
<p ><span>Blocking (rarely)</span></p>
</li>
</ul>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Withdrawal</span></p>
<ul>
<li >
<p ><span>Potential Risks</span></p>
</li>
<ul>
<li >
<p ><span>Changeback</span></p>
</li>
<li >
<p ><span>Money laundering</span></p>
</li>
<li >
<p ><span>Account takeover</span></p>
</li>
<li >
<p ><span>Identity theft</span></p>
</li>
<li >
<p ><span>Bonus abuse</span></p>
</li>
</ul>
<li >
<p ><span>Risk Management Measures</span></p>
</li>
<ul>
<li >
<p ><span>ID verification</span></p>
</li>
<li >
<p ><span>Cash-out verification</span></p>
</li>
<li >
<p ><span>Withdrawal limits</span></p>
</li>
<li >
<p ><span>Withdrawal delays</span></p>
</li>
</ul>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>From registration to verification, from gaming/betting to withdrawal stages, AI-powered risk management tools guarantee the accuracy of the whole process and reduce potential losses that may be brought about by risky players.&nbsp;&nbsp;&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Most software providers&rsquo; services include risk management solutions. In BetConstruct&rsquo;s case, the solution is even automated and AI-based. We understand the importance of protecting B2C operators from possible risks and losses. This is why we have developed our effective AI-powered risk management and anti-fraud tool </span><a href="https://www.betconstruct.com/products/umbrella"><span>Umbrella</span></a><span>, to safeguard our partners from any fraudulent action. Umbrella provides fully automated detection of risky activities, assignment of financial and additional categories, real-time analytics and reports. With a strong focus on AI&rsquo;s integration into risk management tasks, Umbrella significantly reduces human involvement, improves the accuracy and efficiency of all processes and guarantees risk-free growth for your igaming business.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>&nbsp;&nbsp;</span></p>
<p><span>&nbsp;</span></p>`,
  },
  {
    name: 'Artificial Intelligence and Machine Learning in the iGaming Industry',
    slug: 'aiAndMl',
    icon: '',
    path: 'content-management/aiAndMl',
    shortDescription: 'Online gaming is currently' +
      ' among the top industries that effectively' +
      ' use the power of artificial intelligence' +
      ' and machine-learning systems. Read on.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/Artificial.png').default} width="689" alt="">
</div>
<br>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Online gaming is currently among the top industries that effectively use the power of artificial intelligence and machine-learning systems. Artificial intelligence and machine learning are two different concepts that can be easily confused. </span><span>AI</span><span> refers to machines performing tasks typical to human intelligence, e.g. recognising things, planning processes, understanding signs and languages, preventing fraud. </span><span>Machine learning </span><span>includes algorithms and statistical models that computer systems use when performing a specific task. It is regarded as a branch of artificial intelligence. Some practical every-day ML examples include weather predictions, betting predictions in sports tournaments, ads recommendations based on your preferences and a lot more.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Here are some of the most popular AI and ML applications in iGaming:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Risk Management</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>In risk management, the application of top-notch AI-powered tools has really improved the interaction between the components, by automating the entire manual process. Today, most of the manual tasks that once required human involvement, are entirely performed by AI-enabled risk management software. The benefits of automating online gambling risk management tasks are quite clear: cutting costs, saving time, reducing errors, increasing effectiveness, etc. AI-powered risk management tools have impact in the areas of risk mitigation, gaming and betting fraud prevention, predictive analysis provision, and cost reduction related to the risk management staff.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The advanced AI-powered risk management tools allow gaming operators to detect any risky activity in real time, segment players into groups and prevent losses resulting from&nbsp; fraudulent activities. In this respect, BetConstruct offers its own AI-powered risk management tool Umbrella, which provides gaming operators with comprehensive data, timely detection and effective management of risky players. It makes the process of handling risky players much easier for risk managers, allowing them to automatically segment players on the basis of their activities and perform some other important tasks to prevent fraud.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Fraud threatens the reputation of your brand and deters players. Account takeovers, game hacks, fake licensing, credential ripoffs, spam, and bots are difficult to combat using conservative methods, but AI grants you the tools to change the equation. Machine Learning systems that track all the tiniest game events and detect fraud patterns in real time can put an end to malicious activity at your gaming or sports betting platform. The advantage of Machine Learning solutions centers on their ability to learn and improve their algorithms. In comparison to static fraud detection systems, this ability keeps them afloat and impedes their bypassing by fraudsters.</span></p>
<p ><span><span><br /><br /></span></span></p>
<ol start="2">
<li >
<p ><span>Data Collection and Analysis</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>In order to work effectively, AI and machine learning require a lot of data.&nbsp; The more data, the more effectively an AI system can be trained to recognise patterns and develop algorithms to optimise the system&rsquo;s performance. Real-time, accurate and reliable data feeds are very important for the success of any iGaming business. It is a landmark in providing high-quality odds, precise statistical probability, and more confident trading decisions.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Online casinos log hundreds of millions of transactions daily around the world; trained scouts and expert traders collect and deliver data. But large volumes of data can be challenging for human analysts to tackle. Today, there is a growing tendency to trust AI algorithms. After all, no matter how professional scouts or traders are, all human beings can miss details or fail to be super-fast when delivering data.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The situation is different with ML and AI-based software. In particular, BetConstruct has enriched its product line with the AI and ML-powered data scouting tool AJNA, which can deliver accurate data from the field in seconds.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Boosting player engagement and retention&nbsp;</span></>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>In the online gaming industry, AI and ML are also used for improving player engagement and retention. AI and ML tools, integrated into CRM systems, allow gaming operators to track where players come from, collect data about their gaming or betting preferences and offer them highly personalised gaming experiences, ads, game recommendations, promotions and special offers. Tailoring personalised experience for each player is only possible with the help of artificial intelligence.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Artificial intelligence can be used to enhance personalisation of the player experience in a way that manual human processes simply can&rsquo;t. With AI, a user&rsquo;s playing style can be tracked and analysed to help match the user with reward mechanisms that best compliment their playing style and personal motivations.&nbsp; Depending on their game preferences and betting habits, different types of rewards will offer more or less incentive to a player.&nbsp; A player's response to different rewards can also be tracked over time and built into the overall user profile.&nbsp; These incentive programmes build loyalty and retention for an operator, and AI can be used to greatly enhance their targeting and effectiveness.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>AI chatbots are also an important ingredient of customer support. These can handle up to 75% of issues, providing quicker responses and saving operators costs when you face a problem or have a query. BetConstruct&rsquo;s own AI chatbot Hoory is another perfect example of digital assistance.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Promoting responsible gaming&nbsp;</span></>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Gambing addicts are bad news for any prestigious gaming operator. So, reputable gaming platforms take measures that will prevent addictive gaming and promote responsible gaming instead. Thanks to AI and ML systems, handling problematic players has become an easy process. Tools that incorporate artificial intelligence and machine-learning systems make it possible to identify players inclined to addiction as early as possible. The preventive measures include individually designed prevention programmes, voluntary self-exclusion, limit-setting, etc.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>AI can be trained to perform tasks that enhance or automate human processes and also recognise patterns or behavioural changes that can identify potential problems or abuses in early phases. One of the main objectives is to better identify problematic gamblers as early as possible, connect them with good help resources and enable them to self-exclude from activity when needed.&nbsp; The changes in behaviour can be subtle and may include such things as:</span></p>
<ul>
<li >
<p ><span>Time spent indicators - spending more time online, gambling during working hours or odd hours, etc.</span></p>
</li>
<li >
<p ><span>Account activity (cancelled withdrawals, failed deposits, using multiple payment methods)</span></p>
</li>
<li >
<p ><span>Play indicators (chasing losses, changing products, erratic betting, increasing stakes)</span></p>
</li>
</ul>
<p ><span><span><br /><br /></span></span></p>
<ol start="5">
<li >
<p ><span>&nbsp;AML (Anti-Money Laundering) and KYC (Know Your Customer)</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Increasingly, iGaming operators are turning to AI technology to automate many of the processes involved with AML and KYC by inputting and better analysing a broader set of data and infometrics.&nbsp; New tools are being developed. These enable automating processes for:</span></p>
<ul>
<li >
<p ><span>Risk profile assessment</span></p>
</li>
<li >
<p ><span>KYC / player onboarding</span></p>
</li>
<li >
<p ><span>Documentation collection, analysis and archiving for auditing</span></p>
</li>
<li >
<p ><span>Analysing transactional data to identify suspicious activities</span></p>
</li>
<li >
<p ><span>Suspicious Activity Reporting</span></p>
</li>
<li >
<p ><span>Source of funds and source of wealth detection</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>With big data and access to a broader range of financial information, AI will help operators greatly reduce their exposure to potential online criminal activity making the business safer and more secure for everyone.</span></p>
<p ><span>&nbsp;</span></p>`,
  },
  {
    name: 'Land-based solutions',
    slug: 'landbasedSolutions',
    path: 'products-and-solutions/land-based-solutions',
    icon: '',
    shortDescription: 'Set up new businesses from scratch or expand' +
      ' established ones enabling players to bet on both ' +
      'real-time sports and virtual games in physical locations',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/Land-basedsolutions.png').default} width="689" alt="">
</div>
<br>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>It&rsquo;s notable that in some markets betting remains restricted to specific physical premises. Betshops are allowed, but any betting can only happen on site. BetConstruct&rsquo;s Land-based solutions enable operators to set up a new business from scratch or grow an established one in markets where there may be limited or minimal competition. Furthermore, no Internet marketing or other specialist experience is required.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Our Land-based solutions provide your players with unique betting options, enabling them to bet on both real-time sports and virtual games in physical locations. BetConstruct&rsquo;s software package is specially developed for managing land-based operations. We provide physical terminals and equipment from other leading hardware suppliers, and we can also advise on the specifications of setting up a betshop from the ground up.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Products &amp; Features</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Terminal Solution (SSBT)</span></p>
<ul>
<li >
<p ><span>Anonymous and authorised betting</span></p>
</li>
<li >
<p ><span>Member cards (RFID/NFC)</span></p>
</li>
<li >
<p ><span>Admin tool for financial and hardware management</span></p>
</li>
<li >
<p ><span>Cash in/Cash out (payout machines)</span></p>
</li>
<li >
<p ><span>Cash in/Ticket out</span></p>
</li>
<li >
<p ><span>Ticket in/Ticket out</span></p>
</li>
<li >
<p ><span>Bonus systems</span></p>
</li>
<li >
<p ><span>Fully customisable interface</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Odds Display Tool</span></p>
<ul>
<li >
<p ><span>Live/Pre-match odds display</span></p>
</li>
<li >
<p ><span>Template creation process</span></p>
</li>
<li >
<p ><span>Fully customisable interface</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Pocket Betshop</span></p>
<ul>
<li >
<p ><span>Anonymous betting</span></p>
</li>
<li >
<p ><span>Ticket in/Ticket out</span></p>
</li>
<li >
<p ><span>HotKey functionality (configurable hot key setting per market)</span></p>
</li>
<li >
<p ><span>Bonus systems</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Self Service Betting Terminals</span></p>
<ul>
<li >
<p ><span>Processing via cash in/ticket out, ticket in/ticket out</span></p>
</li>
<li >
<p ><span>Pre-pay customer cards and direct login</span></p>
</li>
<li >
<p ><span>Dual screen system for branded POS (point of sale) marketing, statistics,&nbsp;</span></p>
</li>
</ul>
<p ><span>streaming content, etc.</span></p>
<ul>
<li >
<p ><span>Bonus system</span></p>
</li>
<li >
<p ><span>Fully customisable design (drag and drop technology)</span></p>
</li>
<li >
<p ><span>Multilingual and multi-currency interface</span></p>
</li>
<li >
<p ><span>Play with RFID</span></p>
</li>
<li >
<p ><span>Payout machine</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Cashier Client</span></p>
<ul>
<li >
<p ><span>Printable pre-match fixture list generation</span></p>
</li>
<li >
<p ><span>Printable results generation</span></p>
</li>
<li >
<p ><span>Powerful administration and reporting tools</span></p>
</li>
<li >
<p ><span>Single point of management</span></p>
</li>
<li >
<p ><span>Simple and fast user interface</span></p>
</li>
<li >
<p ><span>HotKey functionality (configurable hot key setting per market)</span></p>
</li>
<li >
<p ><span>Booking functionality with WEB site</span></p>
</li>
<li >
<p ><span>Booking functionality with printable generated list</span></p>
</li>
<li >
<p ><span>Bonus systems</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Licences</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct&rsquo;s Land-based/Retail solutions are granted the following licences:</span></p>
<ul>
<li >
<p ><span>ONJN (Romania National Gambling Office) Class II License Decision with the following number: 1017.</span></p>
</li>
<li >
<p ><span>National Manufacturer&rsquo;s Licence by National Gambling Board, South Africa.</span></p>
</li>
</ul>
<p ><span>Common markets</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Land-based solutions are mostly common in Africa, Latin America and Europe.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>All Land-based products are easy to download and set up. Based on partners&rsquo; requirements and settings, we give permission to their users, after which they are allowed to use the product.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Usage from the Operator&rsquo;s Point of View</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Most of the Land-based operators deal with regular players. Our Land-based solutions are round the corner to help them maintain and increase the current profits. We have every land-based solution our operators may need in this industry to attract a special audience, plus an easy and flexible process that allows them to grow more rapidly.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct is offering 4 products that could be used in the Land-based market. Our products give operators an opportunity to accept bets, register players, make several transactions (deposit/withdraw/pay the winning amounts) for Land-based operations.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQ</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Q: What kind of products does Betconstruct offer for Land-based Operations?</span></p>
</li>
</ol>
<p ><span>A: BetConstruct offers several products for Land-based Operations, such as Software for Self-Service Betting Terminals, Cashier Client System, Betshop Terminal, Pocket Betshop and ODDS Display Tool.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: What kind of games does BetConstruct offer in Self Service Betting Terminals?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: BetConstruct offers Sportsbook, Virtual Sports, Casino and Live Casino games in Betting Terminals.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: What Kind of solutions does Betconstruct provide to operators?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: BetConstruct's Land-based software Turnkey solution is available to all operators.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: What kind of licence(s) does Betconstruct have for Land-based solutions?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: Betconstruct has ONJN (Romania National Gambling Office) Class II Licence Decision with the number 1017 and National Manufacturer&rsquo;s Licence by National Gambling Board, South Africa for Land-based solutions.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: How can we buy Self-Service Betting Terminals?</span></p>
</li>
</ol>
<p ><span>A: BetConstruct works with many Hardware Suppliers and is ready to recommend from where to buy Self-Service Betting Terminals.</span></p>
<p ><span id="docs-internal-guid-995ddc77-7fff-6969-df56-3241db0a3906"><br /><br /></span></p>`,
  },
  {
    name: 'Poker',
    slug: 'poker',
    path: 'products-and-solutions/poker',
    icon: '',
    shortDescription: 'Poker games with intuitive design and highly-customisable settings\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/PokerKB.png').default} width="689" alt="">
</div>
<br>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Being one of BetConstruct&rsquo;s most extensive products, Poker requires insight, ability to make calculations and apply probability theory. Poker is an easy-to-learn game of friendly competition, but the strategy involved makes it a challenge to master. When combined with thought, strategy and environmental feedback, it can offer a great deal of enjoyment and appeal. BetConstruct provides cash tables, as well as SPIN&amp;GO, MTT (multi-table tournaments), knock-out and satellite tournaments. Also, guaranteed prize pools are randomly settled depending on the number of players.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Texas Hold&rsquo;em</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Texas Hold'em, beyond a doubt the most popular game of poker globally, has grown in profile as a result of major televised events around the world. It's a big attraction in both online and offline worlds. BetConstruct offers Texas Hold'em in all 3 limits - No Limit, Limit and Pot Limit, as well as in cash, SPIN&amp;GO, Sit&amp;Go and Tournament formats.</span></p>
<p ><span>In Texas Hold&rsquo;em, like in Omaha, blinds are paid by the two players on the left side of the dealer (the dealer is designated by a button which moves clockwise around the table to enable each participant to pay the blinds and have the deal). This initial bet starts the pot. The first player on the left of the dealer button places the small blind which is half the minimum bet, and the next player places the big blind equal to the minimum bet. The rotation of the dealer button and those of blinds assures that every player gets their turn, and no one has an advantage over another in their position.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Omaha</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Similar to Texas Hold&rsquo;em, Omaha uses community cards. However, in this case, a player gets four hole cards, two of which one must use in a combination with community cards in order to get the best poker hand. Due to its high-limit card essence, Omaha is considered an action game, providing your players a higher chance of hitting combinations more frequently. If your players prefer high pots and short waiting between the rounds, then Omaha is what you should offer them. It can bring the benefits of a solid base of players and an increased liquidity in the poker room.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>6+ Hold'em (Short Deck)</span></p>
<p ><span>Short Deck Hold&rsquo;em is an action game very similar to Texas Hold&rsquo;em, except that it&rsquo;s played with a 36-card deck, with all of the 2s through 5s removed, hence the name - &ldquo;6+ Hold'em&rdquo;. Removing all the 2s through 5s, some of the hand rankings change: three-of-a-kind beats a straight, a flush beats a full house, and ace can be used as Hi/Low.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>SPIN&amp;GO</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>SPIN&amp;GO is a type of Hyper-Turbo Sit &amp; Go that gives players a chance to play for a prize pool which is much bigger than a tournament buy-in initially indicates. Each tournament has only three players, and before a SPIN&amp;GO starts, a random draw is held to determine the prize pool that will be 2 to 1000 times higher than the initial buy-in.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Play</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Each poker game starts with players putting a certain amount of money or chips into the pot. This is an obligatory bet or fee called the "blinds". In some cases an ante is also paid which means every player puts a fixed nominal percentage of the minimum stake into the pot. The blinds (and in some cases antes) are the only mandatory wagers to be made, and it&rsquo;s up to each player to decide whether or not they wish to play on or fold. Each player can bet as much as they are able or allowed to depending on the game. The amount of bet or the frequency of betting is determined by the game type, but in case you are betting and nobody calls, you can win without the necessity to show your cards. If the final bet is called, players should show their cards, and the player with the best hand will win. If any player "mucks" their hand, then the hand is declared dead. If the amount in the pot is uneven, and both players have the same hand, the pot is split, and the first active player on the left of the dealer button gets the extra chip. In Hi/Lo games, for instance, the High always gets the extra chip.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Licences</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>To develop partnerships, Poker is all set for being delivered under the following licences:</span></p>
<ul>
<li >
<p ><span>MGA</span></p>
</li>
<li >
<p ><span>Curacao</span></p>
</li>
<li >
<p ><span>GLI (in progress)</span></p>
</li>
<li >
<p ><span>French licence (in progress)</span></p>
</li>
</ul>
<p ><span>These grants are a cornerstone for consistent growth and improvement of the game, as well as a full protection for all players.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Product Features</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Proper poker room ecology</span></p>
</li>
<li >
<p ><span>Windows, Mac, HTML5, IOS native app and new PWA (progressive HTML5 Web client apps) system</span></p>
</li>
<li >
<p ><span>Super user-friendly software for recreational players</span></p>
</li>
<li >
<p ><span>Multiproduct single environment</span></p>
</li>
<li >
<p ><span>CRM, Affiliate and Agent modules</span></p>
</li>
<li >
<p ><span>Fully configurable table, cards face, deck, background, betting slider and preferred seat</span></p>
</li>
<li >
<p ><span>Rotatable advertising space</span></p>
</li>
<li >
<p ><span>Game history video playback</span></p>
</li>
<li >
<p ><span>Spin&amp;Go Tournaments</span></p>
</li>
<li >
<p ><span>Automated chat monitoring</span></p>
</li>
<li >
<p ><span>Opportunity to view monetary details in player currency</span></p>
</li>
<li >
<p ><span>Multi-language lobby</span></p>
</li>
<li >
<p ><span>Configurable sounds</span></p>
</li>
<li >
<p ><span>Lobby and game customisation tools</span></p>
</li>
<li >
<p ><span>Individual branding, fully customisable color skinning&nbsp;</span></p>
</li>
<li >
<p ><span>Lobby Dark/Light Mode</span></p>
</li>
<li >
<p ><span>Tables with straddles, antes and run-in-twice feature</span></p>
</li>
<li >
<p ><span>Traditional 6+ Hold&rsquo;em and PLO5 game types</span></p>
</li>
<li >
<p ><span>Fully manageable loyalty system</span></p>
</li>
<li >
<p ><span>Show/muck functionality</span></p>
</li>
<li >
<p ><span>Mobile app that supports both landscape and mobile views</span></p>
</li>
<li >
<p ><span>Tournament money system</span></p>
</li>
<li >
<p ><span>Flexibility towards operators requests</span></p>
</li>
<li >
<p ><span>Separately dedicated team for gameplay integrity management</span></p>
</li>
<li >
<p ><span>Fish protection and unavailability to use third party trackers</span></p>
</li>
<li >
<p ><span>Fully operating web-based backoffice</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Common Markets</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Poker is the type of game that is spread all over the world. There are approximately more than 100 million players worldwide who play poker on a regular basis. Hence, our markets can be found nearly everywhere. However, there are mostly expanded in the CIS countries: Armenia, Russia, Ukraine, Belarus, Kazakhstan, etc. Also, we can operate in grey markets, as we have an integrated agent system.</span><span><br /><br /></span></p>
<p ><span>User General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>When giving the general description of the game users, the main question comes to the fore - &ldquo;Who plays poker?&rdquo; Well, who doesn&rsquo;t? All people around the world with average incomes and interest in competitive games do play poker and enjoy the game to the maximum.&nbsp;</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>Setup Process</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>To meet specific needs and requirements of your company you need to understand how to use the product and configure your own processes. The set up process of our product is established by account managers. In case our operators connect to the network, the set up process is done by their account manager with only one click right from the BME platform. Moreover, Poker has its own backoffice, that enables all the operators to view the motion of their players and keep track of them.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Usage from the Operator&rsquo;s Point of View</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The effectiveness of the product from the operator&rsquo;s point of view is another story. From their perspective, the most important component is the network which should be a healthy ecosystem full of recreational players. Not only professional but also competitive players should take part in the game to keep the balance and longer player lifetime. It&rsquo;s more beneficial for operators when these two types of users play together and compete against each other in the global network. However, apart from the opportunity to connect to the global network, we enable our partners to own their local network as well.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Obviously, our partner support operates very productively, and the programme is quite stable. Likewise, we are always open to suggestions from our operators to create a better experience for players.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The Most Common Issues Regarding Poker</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The integration of the program is very easy, hence partners do not face difficulties when activating it. However, in case problems arise, our development team is always nearby to immediately solve them.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Here are the most frequent questions about the product:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Q: What is a poker commision or rake?</span></p>
</li>
</ol>
<p ><span>A: Revenue stream for poker is the rake. Poker comission or rake is the percentage taken from the pot, mainly generated from cash games. The rake is usually 5% in case of operating in the global network. After the completion of each hand a rake is taken.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: What platforms is poker available on?</span></p>
</li>
</ol>
<p ><span>A: Poker is available for Windows, Mac (OSx), iOS, HMTL5, PWA (Progressive Web App). Poker has a downloadable client, a web version, a native iOS app and a progressive web app.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: Is poker global hand history available?</span></p>
</li>
</ol>
<p ><span>A: It is possible to view poker hand history if a user played on a table and didn't sit it out. It is done via hand replayer which can be accessed from the top left corner on the table. Yet, global hand history is not available to users, due to our fish protection strategy. It can only be accessed by admins right from the Backoffice.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: How do poker tournaments work in the global network?</span></p>
</li>
</ol>
<p ><span>A: BetConstruct offers various tournaments with guaranteed prize pools. All the costs are covered by BetCOnstruct, and the tournaments are available to all the users in the global network. All operators can create their own local tournaments with the use of Backoffice (BO).</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: What are the available poker tournament types?</span></p>
</li>
</ol>
<p ><span>A: There are various types of poker tournaments, such as the progressive knockout tournaments, classic knockout tournaments, re-entry tournaments, rebuy+add on tournaments, satellites and freerolls being at hand. Spin&amp;Go and Sit&amp;Go tourney formats are also available.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="6">
<li >
<p ><span>Q: Do you have affiliate/agent systems?</span></p>
</li>
</ol>
<p ><span>A: There are both agent and affiliate systems available for poker.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Relation to SpringBME</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct&rsquo;s Poker is also available on the SpringBME platform, though currently we are working on making the global network a separate brand, by the name of BCPoker.</span></p>`,
  },
  {
    name: 'Virtual Sports',
    slug: 'virtualSports',
    path: 'products-and-solutions/virtual-sports',
    icon: '',
    shortDescription: 'Real-money betting on various 3D-designed sports\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/VirtualSportsKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>Virtual Sports</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>General Description</span><span>&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Virtual Sports guarantees realistic, dynamic and fully involving 24/7 gameplay for your audience. The only difference from real sports is that we make the action truly non-stop. Our Virtual Sports offers random races uniquely generated on-demand for instant gameplay and player satisfaction. Odds are offered across multiple bet types and are generated automatically, according to definable margins. With enhanced 3D visualisation and rich sound effects BetConstruct offers 8 Virtual Sports, namely Virtual Football Pro, Virtual Football League, Virtual Football Penalty Kicks, Horse Racing, Greyhound Racing, Virtual Drag Racing, Virtual Bicycle and Marble Racing. Virtual Sports has 300+ partners (the key partner being BBIN) and has gained 40+ awards.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Play</span></p>
<p ><span>The product is based on real data, however its operations are predicated on the RNG algorithm, which helps decide and choose outcomes and final scenarios. The main games are played every 2-3 minutes. Virtual Sports and Casino work according to the same principle of chance and randomness. The main difference is that the odds vary: Virtual Sports enables players to win with high odds.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Included Games</span></p>
<p ><span>Virtual Football Pro</span></p>
<p ><span>As in real football, Virtual Football Pro has several Competition forms: Virtual Football League form, World Cup form, Penalty Kicks that keep players really involved. We offer 480 games daily; every 3 minutes across 40+ betting markets, providing a 24/7 betting experience. Margins are fully configurable, and graphics can be customised with branded backgrounds. This sport type is common in the same markets, where real football is popular, except that the risk is much lower in percentage here on the virtual platform.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Virtual Football League</span></p>
<p ><span>BetConstruct&rsquo;s Virtual League is a top revenue-making solution for operators. This game fuels players&rsquo; interest and engagement, providing an incredible gaming experience for them. Our League format features 8 teams, 112 matches per season, 28 match days, and 4 simultaneous games. Players have a chance to bet 24/7. Operators can configure margins and customise graphics to match their brands.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Virtual Football Penalty Kicks</span></p>
<p ><span>BetConstruct&rsquo;s Virtual Football Penalty Kicks is the best choice</span><span> for the players who are in need of some adrenaline rush.</span><span> It consists of back-to-back penalty kicks from opponent teams very similar to those in real football. We offer 480 games every 3 minutes with </span><span>22+ betting markets.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Horse Racing</span></p>
<p ><span>BetConstruct&rsquo;s Virtual Horse Racing provides an amazing opportunity for horse racing fans to bet on a wide variety of events anytime they want. We offer a race every 2 minutes; a total of 720 games daily. Your players have the ability to choose from 6 to 8 runners per race. The combination of unique betting experience and 3D visualisations based on videos from events in the UK, Ireland and other countries make our virtual horse racing the perfect product for a high ROI. It&rsquo;s a very simplified version of a game that increases customer base and prolongs player lifetime.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Greyhound Racing</span></p>
<p ><span>Since real dog racing events are limited, BetConstruct has created an amazing product which offers betting solutions available on all your selected channels. To make our games more realistic, BetConstruct has derived the characteristics of dogs from real races. More than 720 races are provided daily, every 2 minutes. Your players have the ability to choose from 6 to 8 runners, as well as enjoying Virtual Racing as if it was a real one thanks to real dog racing behaviour. As for graphics, they can be customised with branded backgrounds.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Drag Racing</span></p>
<p ><span>Drag Racing provides a totally new level of engagement for players. It strictly differs from classical races. It is the fastest-paced game that will definitely attract and delight your customers. With enhanced 3D visualisation and sound effects, Virtual Drag Racing experience will make you feel like you are in the drivers&rsquo; seat, thus providing quick and fun entertainment to you.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Virtual Bicycle&nbsp;</span></p>
<p ><span>Cycling is rapidly becoming a high profile sport in different markets around the globe. We offer 720 races daily, every 2 minutes. Punters can choose between 4 or 6 cyclers per round across a wide range of betting markets. It&rsquo;s a simplified game ready to deliver users a stunning new way to play.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Marble Racing</span></p>
<p ><span>BetConstruct offers a brand new Virtual Sports type - Marble Racing, that happens to be our own idea and initiative. It is a captivating competition where individual marbles are pushed across racetracks. We offer 720 races daily, and each new game starts over and over again every 2 minutes. Players are given 10 marbles to choose from and a wide range of betting markets.&nbsp;</span></p>
<p ><span><span><br /><br /><br /><br /><br /></span></span></p>
<p ><span>Licences</span></p>
<p ><span>Virtual Sports with the whole spectrum of its betting and gaming products comes under the following licences:</span></p>
<p ><span>Class II Licence Decision with the following number: 1017.</span></p>
<p ><span>ONJN (Romania National Gambling Office)</span></p>
<p ><span>Type 1 licence - </span><span>MGA (Malta Gaming Authority)</span></p>
<p ><span>Combined Remote Operating licence from the </span><span>UK Gambling Commission</span></p>
<p ><span>Product Features</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Full HD and HD graphics</span></p>
</li>
<li >
<p ><span>Enhanced 3D visualisation and sound effects for a real experience</span></p>
</li>
<li >
<p ><span>Availability as a multi-device solution (online, retail, tablet and mobile)</span></p>
</li>
<li >
<p ><span>6,400+ events per day</span></p>
</li>
<li >
<p ><span>New matches every 3 minutes, across 8 sport types</span></p>
</li>
<li >
<p ><span>Comprehensive content management system</span></p>
</li>
<li >
<p ><span>24/7 real money betting and immediate payouts</span></p>
</li>
<li >
<p ><span>Customisable margins</span></p>
</li>
<li >
<p ><span>Multi-language and multi-currency</span></p>
</li>
<li >
<p ><span>Fast and easy report generation</span></p>
</li>
<li >
<p ><span>Extensive range of statistical analysis</span></p>
</li>
<li >
<p ><span>Hosted service</span></p>
</li>
<li >
<p ><span>Retail solution - optimal streaming capability by placing encrypted videos on site, and Satellite solution (Coming soon and upon request)</span></p>
</li>
<li >
<p ><span>Customisable branding system</span></p>
</li>
</ul>
<p >&nbsp;</p>
<p ><span>Common Markets</span></p>
<p ><span>Virtual Sports is popular in Africa, Latin America and Asia.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span>It is often asked why players choose Virtual Sports. Here&rsquo;s a couple of answers from the user&rsquo;s standpoint:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Virtual sporting events are available 24/7;</span></p>
</li>
<li >
<p ><span>Virtual sports do not require real sports knowledge;</span></p>
</li>
<li >
<p ><span>Virtual sports do not rely on external factors (Games are not cancelled or postponed due to adverse natural phenomena, flight cancellations or similar issues).</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup process</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The set up process is done in the following way: partners add virtual sports tabs to their websites through the configuration process and then activate the preferable games from Backoffice.&nbsp;</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>Usage from the Operator&rsquo;s Point of View</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>It goes without saying that online gambling has experienced an explosive growth and it still continues to take the industry by storm. As players call for a thrilling experience, forward-thinking partners need to deliver interesting, unique and engaging games to them. Virtual Sports, with all its sport types, is a wonderful opportunity for our operators and a powerful contribution to their revenue streams. Building a virtual sports platform gives them a chance to succeed in this competitive market and expand their reach. Our operators have an opportunity to consistently leverage Virtual Sports on their websites.&nbsp;</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>FAQs</span></p>
<ol>
<li >
<p ><span>Q: How do Virtual Sports generate a result?</span></p>
</li>
</ol>
<p ><span>A: All the Virtual Sports games are created based on randomly generated scenes created by </span><span>Betconstruct.com</span><span>. For all Virtual Sports results, BetConstruct uses a random number generator (RNG) to determine the outcome.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: What bet types are available for BetConstruct Virtual Sports?</span></p>
</li>
</ol>
<p ><span>A: Single, Multiple, and System bets are available for BetConstruct Virtual Sports.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: What is the supported quality video resolution for Virtual sports?</span></p>
</li>
</ol>
<p ><span>A: Virtual Sports supports 720p and 360p video resolution, depending on the speed of your Internet connection and device.&nbsp;</span></p>
<p ><span>720p-1500 kbps is available for PC, Live Monitors, Betshops, Terminals and 360p-700 kbps - for Mobile Devices.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: How many Virtual Sport games does BetConstruct offer daily?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: BetConstruct offers more than 6400+ games daily, providing a 24/7 betting experience for players.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: What types of Virtual Sports are offered by BetConstruct?</span></p>
</li>
</ol>
<p ><span>A: BetConstruct offers 8 Virtual Sports, namely Virtual Football Pro, Virtual Football League, Virtual Football Penalty Kicks, Horse Racing, Greyhound Racing, Drag Racing, Virtual Bicycle and Marble Racing.</span></p>`,
  },
  {
    name: 'Casino Suite',
    slug: 'casinoSuite',
    path: 'products-and-solutions/casino-suite',
    icon: '',
    shortDescription: '7,000 casino games from BetConstruct and other major suppliers\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/CasinoSuiteKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Online casino is an excellent route to portfolio diversification, enhanced appeal to existing and new players and sustainable business growth. BetConstruct provides over 8,000 desktop games, 7,000 out of which are available on mobile allowing the players to enjoy games on the go. Our offering stands out in the industry due to our policy of constantly adding new games and establishing relationships with other suppliers. Our online casino games are a pure wonder of the gaming industry delivering a unique combination of excitement, involvement and entertainment. We keep adding new and stunning games and slots that can be integrated easily into any existing platform and join our operators&rsquo; portfolio.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>To satisfy your demands we offer the following categories:</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Classic Slots</span></p>
<p ><span>Video Slots</span></p>
<p ><span>Fishing Games</span></p>
<p ><span>Scratch Games</span></p>
<p ><span>Table Games</span></p>
<p ><span>Live Dealer</span></p>
<p ><span>Video Poker</span></p>
<p ><span>Virtual Games</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>On the technical part, our set of built-in promotional tools produce a positive impact on your revenue streams and customer lifetime value.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Product Features</span></p>
<ul>
<li >
<p ><span>Certified RNG systems</span></p>
</li>
<li >
<p ><span>Bonus management system</span></p>
</li>
<li >
<p ><span>Casino tournaments management system</span></p>
</li>
<li >
<p ><span>Game Recommendation System</span></p>
</li>
<li >
<p ><span>Jackpot Engine</span></p>
</li>
<li >
<p ><span>Innovative designs, powerful graphic engines, 3D animation</span></p>
</li>
<li >
<p ><span>Classic and Video Slots, Table Games, Video Poker, Virtual Games, Fishing Games</span></p>
</li>
<li >
<p ><span>Global and local jackpots</span></p>
</li>
<li >
<p ><span>50+ new games monthly</span></p>
</li>
<li >
<p ><span>Multi-channel, multi-currency and multilingual</span></p>
</li>
<li >
<p ><span>Cashback/Rakeback system</span></p>
</li>
<li >
<p ><span>Backoffice reporting and monitoring tools</span></p>
</li>
<li >
<p ><span>Full and customised risk management</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Licences</span></p>
<p ><span>Casino Suite is delivered under the following licences: UKGC, MGA , SGA, Curacao, Spillemyndigheden (The Danish Gambling Authority) (in process).</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span>A wide range of online casino games are offered to both novel and experienced players. There are irreplaceable hours of playing time for them to enjoy the feature-rich games with innovative designs, powerful graphic engines, user-friendly interfaces and intuitive navigation. Our casino games and diverse slots fuel curious and passionate players&rsquo; interest and make an excellent engagement booster.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span>The product can be set up with just one click. However, in case providers require additional documentation by some regulations, they need to contact their Account Manager or Project Manager to help them set it up.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Usage from the Operator&rsquo;s Point of View</span></p>
<p ><span>We provide a wide variety of games and categories suitable for every gambler with different tastes and interests, an important distinction that is very profitable from operators&rsquo; point of view. Also, various promotional tools are offered with the chance of getting the desired result. Consequently, high stakes and non-stop playing experience are guaranteed, allowing operators to reap the maximum benefits.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Q: What channels are available for the Casino?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: The product is available on Mobile (Android and iOS), Web and in Betshops.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: Do you have any promotional tools to advertise our games?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: We have various promotional tools, such as tournaments, bonuses and jackpots. Click the link below to find out more: </span><a href="https://www.betconstruct.com/products/casino-suite"><span>https://www.betconstruct.com/products/casino-suite</span></a><span>.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: What Bonuses do you offer?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: Currently, you can set up 5 types of bonuses through the promotional tools section of our backoffice: Deposit Bonus, Manual Bonus, FreeSpins, FreeBets and Skill Games Bonus.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: Do you have a Bonus Engine?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: One of the promotional tools we offer our partners is the Bonus Management System. They can create and maintain various types of bonuses through our system.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: What types of bonuses can I create?</span></p>
</li>
</ol>
<p ><span>A: Our Bonus Management system allows our partners to create several types of bonuses, such as Deposit Bonus, Manual Bonus, FreeSpins Bonus, etc..</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="6">
<li >
<p ><span>Q: Do you have a Tournament Engine?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: One of the promotional tools we offer our partners is the Tournaments Management Engine. They can create, maintain and analyse various types of casino tournaments through our system.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="7">
<li >
<p ><span>Q: Do you have a Jackpot Engine?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: One of the promotional tools we offer our partners is the Jackpot Engine. For more information, please contact your account manager.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="8">
<li >
<p ><span>Q: Do you have a Cashback Engine?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: One of the promotional tools we offer our partners is the Cashback Engine. For more information, please contact your account manager.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Relation to BME</span></p>
<p ><span>Casino Suite is also managed through BME.</span></p>`,
  },
  {
    name: 'Esports',
    slug: 'esports',
    path: 'products-and-solutions/esports',
    icon: '',
    shortDescription: 'Make bets on the most famous Esports' +
      ' championships: LoL, Overwatch, CS:GO, DOTA2, KoG, Starcraft, and more.',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/Esports.png').default} width="689" alt="">
</div>
<br>
<p ><span>General Description</span></p>
<p ><span>Esports (also known as electronic sports, e-sports, or eSports) is a form of multiplayer video game competitions played by professional players against one another, individually or in teams. It is a powerful product developed in-house by BetConstruct to increase betting opportunities for players. Our specialised Esports department provides live betting on 24,000+ Esport matches of 12 different game types from around the world from. Whilst many of these were manually traded, we currently have algorithms for League of Legends and Mortal Combat, with more in development. Our offering includes eFootball (using FIFA 2020 from EA), eBasketball videos (using NB2K20 from 2K), eTennis (using Tennis World Tour) and Mortal Combat. For the popular League of Legends, Dota2, Counter Strike CS:GO, StarCraft 2, StarCraft, Overwatch, King of Glory, Hearthstone, Call of Duty, Rocket League, Rainbow 6, PUBG and Fortnite games BetConstruct covers 500+ tournaments annually. On average, we provide 14,000+ games each streamed in over 50+ markets.</span></p>
<p ><span>Since both Live and Pre-match matches are available, exclusive video streaming is also included, and the matches are live-recorded right from the BetConstruct secure facility. What&rsquo;s more, BetConstruct enables operators to offer their players a unique chance to bet on exclusive Esports content even during the quiet hours on the schedule to boost players&rsquo; interest and increase the sportsbook engagement.</span></p>
<p ><span>How to play</span></p>
<p ><span>Players are competing against each other in teams at a professional level, regularly winning huge amounts of money in the form of prizes. These Esports players work under contract with various organisations, practicing and competing in the same way as football or basketball players do. Depending on the game they play, a number of tournaments and events are held every year, including prizes raffled in hundreds of thousands of dollars, and sometimes even millions.</span></p>
<p ><span>Licences</span></p>
<p ><span>For the licencing community, there are three basic avenues into the world of esports: leagues, teams and players.</span></p>
<p ><span>Betconstruct's Esports is licenced by:</span></p>
<ul>
<li >
<p ><span>Gambling Software Operating Licence from the UK Gambling Commission</span></p>
</li>
<li >
<p ><span>Class II Remote Gaming Licence from ONJN (Romania National Gambling Office)</span></p>
</li>
<li >
<p ><span>Online Sports Betting Licence from French ARJEL</span></p>
</li>
<li >
<p ><span>Type 2 (Fixed Odds/Live Betting) B2C/B2B Licence from Malta Gaming Authority</span></p>
</li>
<li >
<p ><span>National Manufacturer Licence from National Gambling Board, South Africa</span></p>
</li>
</ul>
<p ><span>Product Features</span></p>
<ul>
<li >
<p ><span>12,000+ unique live events monthly</span></p>
</li>
<li >
<p ><span>5,000+ pre-match events</span></p>
</li>
<li >
<p ><span>15+ major championships</span></p>
</li>
<li >
<p ><span>HD quality streaming</span></p>
</li>
<li >
<p ><span>Expert risk management</span></p>
</li>
<li >
<p ><span>100+ markets and 20+ special markets</span></p>
</li>
<li >
<p ><span>Advanced betting tools: Edit Bet, BetCloud, SuperBet, Counter-offer, BetBuilder</span></p>
</li>
<li >
<p ><span>Cash-out types: Partial, Full, Auto</span></p>
</li>
<li >
<p ><span>Bonus types: Freebets, Accumulator Bonus, Wagering Bonus, Profit Boost</span></p>
</li>
<li >
<p ><span>Different odds formats (Decimal, Fractional, American, Hong Kong, Indo, Malay)</span></p>
</li>
<li >
<p ><span>Videos streamed in RTMP, SLDP, HLS protocols</span></p>
</li>
<li >
<p ><span>Reporting to track and monitor the number of matches streamed/watched per month, the countries, etc.</span></p>
</li>
</ul>
<p ><span>Common markets</span></p>
<p ><span>Esports have already spread so widely it&rsquo;s played globally, regardless of the continent. However, the most common markets where the product has gained immense popularity are China, Korea, most of the European countries, etc.</span></p>
<p ><span>User General description</span></p>
<p ><span>One of the most frequently asked questions is &ldquo;Who is Esports for?&rdquo;. The Esports community is growing incredibly fast. Gamers from around the world are embracing it, swarming to tournaments like moths to a flame. Viewers also tune in, making Esports one of the most viewed sports out there. You might assume that the vast majority of hardcore gamers are single teenage boys and middle-aged men living in their parents&rsquo; basements. Well, this is not the case. In fact, the demographics of Esports are persistently becoming more and more diverse.</span></p>
<p ><span>In general, a whopping 82% of viewers were once male. 52% of them were from the US, while the other 48% from Europe, 18% of which were from Germany, 18% from the UK, and the remaining 8% from other various European countries. 75% of these viewers were between the ages of 18 and 34, and 44% were college students. This is a fairly wide range even when compared to other sports.</span></p>
<p ><span>Setup Process</span></p>
<p ><span>Within BetConstruct&rsquo;s Springbuilder, Esports has its own page, which, once created, only needs colouring and developing, since the layout automatically comes with it. Data is provided by traders. When doing the setup through BetConstruct CMS, operators can contact their Account Managers to get help from them in the process.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs&nbsp;</span></p>
<ol>
<li >
<p ><span>Q: What is Esports?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: Esports is a form of multiplayer video-game competitions played by professional players against one another, individually or in teams.&nbsp;</span></p>
<ol start="2">
<li >
<p ><span>Q: What type of games does Esports include?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: Esports includes </span><span>Multiplayer online battle arena (MOBA)</span><span> like League of Legends and Defense of the Ancients 2, </span><span>Real-time strategy games</span><span> like StarCraft 2, </span><span>First person shooters </span><span>like Counter-Strike: Global Offensive and Rainbow Six, </span><span>Battle royale games</span><span>, such as PlayerUnknow&rsquo;s Battlegrounds, </span><span>Fighting games</span><span> like Mortal Kombat and </span><span>Sports games</span><span> such as FifaEs.</span></p>
<ol start="3">
<li >
<p ><span>Q: What Esports games are intended for betting?</span></p>
</li>
</ol>
<p ><span>A: We offer the most popular Esports games, namely Dota2, Counter Strike GO, League of Legends, StarCraft, StarCraft2, PUBG, Fortnite, Hearthstone, Heroes of the Storm, Call of Duty, Artifact, Rainbow 6, World of Warcraft, World of Tanks, King of Glory, Clash Royal, Rocket League, Quake, Warcraft 3, Overwatch and Smite. These games are acceptable for betting.</span></p>
<ol start="4">
<li >
<p ><span>Q: What are the rules of Esports and how to win the games?</span></p>
</li>
</ol>
<p ><span>A: The rules for winning Esports matches vary from one game to another. Here is the list of some of the major Esports games and the ways to win them:&nbsp;</span></p>
<p ><span>League of Legends and Dota 2 </span><span>&ndash; destroy the opponents&rsquo; main building (the Nexus in LoL and the Ancient in Dota 2),</span></p>
<p ><span>Starcraft 2</span><span> &ndash; terminate all the opponents' buildings,</span></p>
<p ><span>Hearthstone</span><span> &ndash; reduce the opponents' Champion to 0 health points,</span></p>
<p ><span>Counter-Strike: Global Offensive</span><span> &ndash; win 16 rounds by either planting and effectively detonating a bomb or averting the opponent from planting and setting off a bomb.</span></p>
<ol start="5">
<li >
<p ><span>Q: What is important to consider while choosing an Esports team to bet on?</span></p>
</li>
</ol>
<p ><span>A: When betting on an Esports team, there are several things you might want to keep in mind. For instance, you need to take into account such facts as the team replacing a player or the players being in a good / bad shape while playing against the other team in the match you have placed a bet, etc.</span></p>
<ol start="6">
<li >
<p ><span>Q: What are the most popular Esports competitions?</span></p>
</li>
</ol>
<p ><span>A: The most popular Esports competitions are FPS (first-person shooters) and MOBA (multiplayer online-battle arena) games &ndash; the biggest names in the Esports industry leading to both ends. League of Legends and Dota 2 hold the line for MOBA, CS:GO and Rainbow Six Siege - for FPS. Overwatch is basically the golden middle between the two extremes, having aspects from the both genres combined into one beautiful gameplay experience.</span></p>
<ol start="7">
<li >
<p ><span>Q: Where can one watch Esports?</span></p>
</li>
</ol>
<p ><span>A: You can watch Esports live broadcasts on our website directly. All you need to do is simply choose the match you want to watch from our list of live games and that's it. To do so, however, you have to register or have an account or you can merely watch the live games on Twitch.tv.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Relation to SpringBME</span></p>
<p ><span>Esports is also available on the SpringBME platform with a new and eye-catching design.</span></p>`,
  },
  {
    name: 'Live Casino',
    slug: 'liveCasino',
    path: 'products-and-solutions/live-casino',
    icon: '',
    shortDescription: 'Enjoy the multi-profile, highly customisable,' +
      ' user-friendly and ever-growing portfolio of Live Casino games.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/LiveCasinoKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct&rsquo;s Live Casino solution is a unique multi-profile game offering. An innovative, highly customisable and user-friendly gaming interface breathes unchallengeable life into your business and attracts loyal players accustomed to higher wager values. To provide longer player lifetime and bring more revenue growth opportunities for you, we have adopted the strategy of delivering a complete suite of games. Our ever-growing portfolio includes Live Baccarat, Live Dragon Tiger, Super Six Baccarat, Live Bet-on-Poker, Live Blackjack, Live Roulette, Live Bet-on Teen Patti, Casino Hold&rsquo;em and a few more games which are currently in development.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct has built an extra level of entertainment through multiple game bonuses and promotions that increase player engagement while extending playing hours and driving more bets. When it comes to omni-channel deployment, our offering is available on any device, be it retail betting shops or any type of a mobile gadget.</span></p>
<p ><span>As a trending entertainment, Live Casino keeps taking the gaming and betting industry by storm, pushing operators to the top charts of the market.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Baccarat</span></p>
<p ><span>Baccarat, also known as &ldquo;Punto Banco&rdquo;, is one of the oldest and most popular casino games all over the world. It is especially popular among high rollers, Asian and American gamblers. It is a comparison card game played between two hands, the "Player" (Punto) and the "Banker" (Banco), against each other. &ldquo;Baccarat&rdquo; means the number of points on either the Player&rsquo;s hand or the Banker's hand which is equal to zero. The game is played with 8 decks of 52 cards and an unlimited number of participants.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Bet-on-Poker&nbsp;</span></p>
<p ><span>Bet-on-Poker is a version of the very popular Texas Hold'em Poker. The difference between these two is that in this solution the players do not play against the casino, not against each other. They receive odds based on the chance of winning with the poker hand(s) they have bet on. In this specific version of Poker, there is no winning &ldquo;pot&rdquo;.</span></p>
<p ><span>Bet-on-Poker is an online multiplayer game in which an unlimited number of players can place bets on each box or playing position. There are four betting rounds during which players can bet as many times and on as many different hands as they wish.</span></p>
<p ><span>The aim of the game is to bet on the hand that has the highest possible five-card hand combination using the two initial cards dealt with each betting position and the five community cards (the Board). The hand(s) having the highest five-card value combination among the others wins.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Live Bet-on Teen Patti&nbsp;</span></p>
<p ><span>Live Bet-on Teen Patti or 3 Patti (meaning &lsquo;three cards&rsquo;) is a kind of poker that is a little bit different from the original game. It is widely spread all across India. The play-card game itself is a skill tech game, represented in a live casino game format, with such skill game elements as in BlackJack.</span></p>
<p ><span><span><br /><br /><br /></span></span></p>
<p ><span>BlackJack</span></p>
<p ><span>BlackJack (after Roulette) is probably the second most popular casino game in the world. This play-card game has many variations and is known by different names, such as &ldquo;Pontoons&rdquo;, &ldquo;Twenty-one&rdquo; or &ldquo;Ponies&rdquo;. BlackJack is always played between a dealer and a group of players. The aim of the game is to beat the dealer with a hand of cards that does not go over 21. It can be played with a single deck or multiple decks. In our Casino, BJ is played with 8 decks of 52 cards.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Dragon Tiger</span><span>&nbsp;</span></p>
<p ><span>Dragon Tiger is a very simple and fast-paced game of luck. It was first introduced in Cambodia and is especially popular among Asian gamblers. Live Dragon Tiger is a comparison card game played between two hands, the "Dragon" and the "Tiger". It represents a symbolic battle between opposing yet complementary forces of Yin (dark) and Yang (bright). In Chinese culture, the dragon and the tiger are considered equal rivals fighting an endless battle. In the Live Dragon Tiger game, one card is dealt with the Dragon hand and the other one with the Tiger hand. No additional cards are dealt.</span></p>
<p ><span>The objective of the Dragon Tiger card game is to guess which hand holds the highest card or whether it will be a Tie.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Hi-Lo</span></p>
<p ><span>Live Hi-Lo is a simple casino game. The dealer draws one face-up card onto the table and you are supposed to guess whether the next card to be dealt is higher, lower, or equal in value to the face-up card. If you guess correctly, you win the displayed payout. If you lose, your wager is lost. An unlimited number of players can play simultaneously at one Hi Lo table, and each player can choose different options during the game.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Keno</span></p>
<p ><span>Keno is a simple game of chance, similar to the lottery. The game originated in ancient China. According to the legend, its popularity helped raise funds in times of war and even fund expensive projects such as the construction of the Great Wall of China. This straightforward and slow-paced game is offered in many land-based and online casinos all over the world. The aim of the Keno game is to guess which numbers from 1 to 80 are among the twenty numbered balls generated by the Keno machine. An unlimited number of players can take part in this multiplayer game simultaneously, playing against the Casino, and not against each other. The house edge is higher when compared to other casino games, like Poker, but players have a chance to win a large amount of money by placing a relatively small bet.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Casino Hold&rsquo;em</span><span>&nbsp;</span></p>
<p ><span>Casino Hold&rsquo;em is a variation of the popular Texas Hold&rsquo;em poker. The difference between these games is that in Casino Hold&rsquo;em you play against the house, and not against other players. The aim of Casino Hold&rsquo;em is to beat the dealer&rsquo;s five-card hand by making the best possible five-card hand. The player&rsquo;s and the dealer&rsquo;s best hands are made out of the two dealt cards and five community cards on the table. An unlimited number of players can play at one Casino Hold&rsquo;em table at the same time, and the dame allows each player to choose different options. Each player can take only one seat at the table.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Live Pai Gow Poker</span></p>
<p ><span>Live Pai Gow Poker is another type of poker that has seen considerable popularity from players around the world over the years. Pai Gow Poker, also called Double Hand Poker, is a version of Pai Gow played with cards instead of Chinese dominoes. In this modern approach to the game there is no need to have experience in poker. The aim of the game is simple - to beat the banker. The banker can be the dealer or another player at the table. The game is played with one deck of 52 cards in each round. An unlimited number of players can take part in the game. Both players and the dealer receive seven playing cards and make two separate poker hands, a five-card &ldquo;High hand&rdquo; and a two-card &ldquo;Low hand&rdquo;. To win, the player's two hands must be higher than the dealer's two hands, or the player&rsquo;s &ldquo;High hand&rdquo; should be higher and the &ldquo;Low hand&rdquo; should be equal to the dealer&rsquo;s hands.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Roulette</span></p>
<p ><span>European/Single Zero Roulette is one of the oldest, most famous and attractive gambling games in the world. It&rsquo;s an incredibly simple game of luck, that guarantees non-stop playing experience. Roulette is played by spinning a small ball around a wheel with thirty-seven numbered pockets (from 0 to 36). When the ball comes to rest in one of these pockets, the winning number is defined. The aim of the game is to accurately predict the number, which the spinning ball will land at. By guessing the correct number, players earn a payoff on their bet. The amount of the payoff depends on the nature of the bet placed. Bets are placed on a table or layout that displays all of the standard betting positions.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Rusky Poker&nbsp;</span></p>
<p ><span>Rusky Poker (Russian Poker) is a highly engaging version of poker. The aim of the game is to beat the Dealer's five-card poker combination with your five-card hand. Rusky Poker is played against the Dealer (the Casino) with one 52-card deck, without Jokers.</span></p>
<p ><span>Our Live Casino&rsquo;s Rusky Poker is a multiplayer game: an unlimited number of players can play, and each player can choose from different options offered during the game.</span></p>
<p ><span>The game uses standard poker rules for ranking and comparing hands, with the lowest being the Ace. In case the Dealer qualifies, players are paid according to a fixed payout scale on their "Bet" if their hand is better than the Dealer's. Otherwise, they lose. There are additional options for players to stake extra money: exchange cards, buy the 6th Card, insure against the Dealer failing to qualify or buy a card for the Dealer.</span></p>
<p ><span>Rusky Poker has a feature that is non-typical of the classic poker: players can be paid for two poker combinations. Both payments are based on a joint assessment of the odds for each combination.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Six Baccarat</span></p>
<p ><span>Super Six Baccarat, a variation of Baccarat (also known as &ldquo;Punto Banco&rdquo;), is one of the oldest and most popular casino games around the world. Super Six Baccarat is a comparison card game played between two hands, the "Player" and the "Banker". &ldquo;Baccarat&rdquo; means the number of points on either the Player&rsquo;s hand or the Banker's hand which is equal to zero. In Super Six Baccarat, the user does not play against other users or the Dealer, but against himself, The number of participants in the game is unlimited. To win in the Super Six Baccarat card game, the Dealer or the Player should make a hand with a total value closer to 9, or it should be a Tie. This game is played with 8 decks of 52 cards:&nbsp; Aces count as 1; 2, 3, 4, 5, 6, 7, 8, 9 count their value; 10 and face cards count as 0.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Swift Roulette</span></p>
<p ><span>Swift Roulette is a relatively new game based on the Standard European roulette, which combines 8 different Roulette tables in one view. It&rsquo;s an incredibly unique game that enables our players to play faster without any betting time, simply placing bets and clicking on the Spin button. Then, the video of the table closest to the upcoming outcome is zoomed in for the player, and the result of the bets is determined based on the result of that table. The aim of Swift Roulette is to accurately predict what number the spinning ball will land at. By guessing the correct number, players earn a payoff on their bet. The amount of the payoff depends on the nature of the bet placed. Bets are placed on a table or a layout that displays all of the standard betting positions.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Switch Blackjack</span><span>&nbsp;</span></p>
<p ><span>Switch Blackjack is a variation of Blackjack that allows players to play with two hands and exchange cards between their hands to make the best Blackjack hand. BlackJack itself is a combination of an Ace and a face card or an Ace and a Ten with the first two cards. BlackJack beats all other card combinations. The aim of the game is to beat the dealer's hand with a hand not exceeding 21. The value of the hand is the sum of all the playing cards: Face cards count as 10; Aces&rsquo; count equals either 1 or 11 (player's choice); all other cards count as their face value.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Product Features</span></p>
<ul>
<li >
<p ><span>Real games in real time 24/7</span></p>
</li>
<li >
<p ><span>HD to full HD quality streaming</span></p>
</li>
<li >
<p ><span>Multiple providers via a single channel</span></p>
</li>
<li >
<p ><span>HTML5 game interface</span></p>
</li>
<li >
<p ><span>Broadcast in 6 languages</span></p>
</li>
<li >
<p ><span>Live chat with dealers and between players</span></p>
</li>
<li >
<p ><span>Jackpot Engine triggering random wins for players</span></p>
</li>
<li >
<p ><span>Flexible customisation</span></p>
</li>
<li >
<p ><span>Additional and side bets in each game</span></p>
</li>
<li >
<p ><span>Customisable limitation for any currency and any market</span></p>
</li>
<li >
<p ><span>Side bet control</span></p>
</li>
<li >
<p ><span>Multi-game view</span></p>
</li>
<li >
<p ><span>Multi-camera view</span></p>
</li>
</ul>
<p ><span>Licences</span></p>
<p ><span>Most of the Live Casino games come under the UKGC, MGA and Curacao licences, thus inspiring more confidence in both operators and players. Licencing of the rest is in progress.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Common Markets</span></p>
<p ><span>The solution is common in 20+ markets.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span>This incredible library of the most popular games increases customer base and supports their needs more extensively. Our Live Casino spices up players&rsquo; interest and engagement, provides them with more unique gaming and betting options, and lets them have a whale of a time. Everyone with passion and curiosity towards our amusing games can fully enjoy this lucrative portfolio.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span>To set up Live Casino, Project Management provides us with a Partner ID and preferred game limits on the basis of which we enable games. Also, there is the BME platform, where all our licenced games are available.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Usage from the Operator&rsquo;s Point of View</span></p>
<p ><span>With continual expansion, BetConstruct&rsquo;s Live Casino gives the operators cross-selling and revenue-growth opportunities. There is a complete freedom of customisation and activation of our spectacular games on their websites, as well as guaranteed high stakes and non-stop playing experience for their players.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<ol>
<li >
<p ><span>Q: What Live Casino games do you offer?</span></p>
</li>
</ol>
<p ><span>A: We offer you a wide range of world famous live casino games such as Live Bet on Poker, Live Blackjack, Switch Blackjack, Live Roulette, Swift Roulette, Live Baccarat, Live Super Six Baccarat, Dragon Tiger, Casino Hold'em, Bet on Teen Patti and more.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: Does Live Casino operate under a licence?</span></p>
</li>
</ol>
<p ><span>A: BetConstruct is licenced by the UK Gambling Commission's Combined Remote Operating Licence, as well as MGA and Curacao licences, which provide the highest level of security for players.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: Are there any side bets in Live Casino?</span></p>
</li>
</ol>
<p ><span>A: Yes, there are. We offer over 30 side bets on different games. Complex statistics and different limits are available for each table in each game.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: Do you have betting limits in Live Casino?</span></p>
</li>
</ol>
<p ><span>A: You can find both the Maximum allowed bets and the Minimum allowed bets on the "TABLE LIMITS" window.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: Can I customise the streaming quality and audio settings?</span></p>
</li>
</ol>
<p ><span>A: Sure. You can use the settings tab located on the menu to quickly and easily adjust the streaming quality or audio settings to suit your needs.</span></p>
<p ><span>&nbsp;</span></p>
<ol start="6">
<li >
<p ><span>Q: How many live casino tables can I play at the same time?</span></p>
</li>
</ol>
<p ><span>A: We provide a multi-game viewing technology that allows you to stream multiple games on one screen at the same time. So you can play multiple games simultaneously.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Relation to BME</span></p>
<p ><span>Live Casino is similarly available on the SpringBME platform.</span><span><br /><br /></span></p>`
  },
  {
    name: 'Predictor',
    slug: 'predictor',
    path: 'products-and-solutions/predictor',
    icon: '',
    shortDescription: 'Drive higher traffic and attract' +
      ' more bettors with this free-to-play, ' +
      'no-licence and easy-to-integrate forecast game.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/Predictor.png').default} width="689" alt="">
</div>
<br>
<p ><span>Predictor</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Being a unique and engaging game, Predictor is specifically for those players who are not using Sportsbook yet. Since this solution is considered a free-to-play game, no licence is required for its operations. Instead, you easily integrate the game into your website with an ultimate goal to attract the players to Sportsbook and later convert them into bettors.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>By integrating Predictor, you give players an ability to make forecasts on the end-results for real weekly matches and win free bets. The closer the predictions to the results, the higher the rank of a player on the leaderboard. As a prize for their accurate answers, players receive free bets that can then be utilised in Sportsbook with real wagers and a wider range of available markets to bet on. This way, you can convert Predictor players into Sportsbook users and boost your revenue from the existing betting channel. To create an even more engaging experience for players, the Organiser determines and announces a prize pool for each round and each global round in the promotional form of a free bet or real money. For each round, as well as the global round, the Organiser sets a number of winning positions followed by the prize pool distribution process.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Play</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The game consists of rounds that can include matches from different competitions. In Predictor, participants can make predictions regarding the sports matches offered by the Organiser and thus accumulate points. As a result of correct predictions, participants accumulate points and take positions on the leaderboard. They can do so as a result of one round, as well as the global round. Points can be accumulated if they foretell the correct score of the predicted match, the match outcome, the difference of the match goals, the number of the goals during the match, as well as the team to score first during the match.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Product Features</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>The prize distributions on the leaderboard decided by operators</span></p>
</li>
<li >
<p ><span>Two types of game: round and global round tournaments</span></p>
</li>
<li >
<p ><span>&ldquo;Smart pick&rdquo; with odds feed data-based predictions</span></p>
</li>
<li >
<p ><span>Custom contest with matches from different leagues</span></p>
</li>
<li >
<p ><span>Statistics, including League Tables and Last Matches</span></p>
</li>
<li >
<p ><span>Real money bet-on version available upon request</span></p>
</li>
<li >
<p ><span>5 prediction types: correct score, goal difference, total goals, first team to score, match result</span></p>
</li>
<li >
<p ><span>&ldquo;Smart point&rdquo; calculation depending on the number of participants and their predictions</span></p>
</li>
<li >
<p ><span>Global network rounds</span></p>
</li>
<li >
<p ><span>Multiple x2 feature in the round(s)&nbsp;</span></p>
</li>
<li >
<p ><span>Predictions on Tennis, Basketball, American Football, Baseball &amp; Volleyball matches (coming soon)</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Common Markets</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Predictor is widespread in all markets, mostly in Europe, as well as in the UK, the USA, Russia and Latin America.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span><br /></span><span>The main reason why operators need to set up Predictor is to both acquire new users and retain the existing ones. To increase customer base, operators determine a certain prize pool and start to promote the game using such channels, as, for example, local sports websites for statistics, sports news sites, forums, social sites, etc. As for keeping their players, they use internal messages, calls, SMS, email messages, banners, and so on. Overall, the game can be seen as a product and service through which operators grow the number of users and try to retain them. Hence, a stunning new way is delivered to them, and both beginners and new users can enjoy this incredible gaming experience.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The process of activating the game on the operators' sites is carried out manually. Various configurations are set, such as sports and leagues, rounds, statistics, etc., and it is possible to use, for example, a jersey instead of a logo, depending on the specific market.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Usage from the Operator&rsquo;s Point of View</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Predictor is a perfect match for our operators, given that they need to acquire as many users as possible to expand their footprint. To secure the number of players on the platform, operators announce a prize pool in the form of a promotion. Hence the customer base is increased. From the technical point of view, operators can make use of the product through project management: round reports, leaderboard results, match statuses, prediction analyses can be obtained upon request.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Q: How many soccer leagues are available in Predictor?</span></p>
</li>
</ol>
<p ><span>A: Our product supports almost all soccer leagues. For much detailed information on the availability of soccer leagues, you need to inquire directly.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: Does Predictor have real-time updates?</span></p>
</li>
</ol>
<p ><span>A: During a match, Predictor maintains real-time updates that include the change of results, minutes, points earned, etc.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: Which channels are available in the Predictor game?</span></p>
</li>
</ol>
<p ><span>A: Predictor has responsive design and supports web, tablet and mobile versions.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: Do I need a licence to operate?</span></p>
</li>
</ol>
<p ><span>A: It mainly depends on the region, but for the most part no licence is required.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: What do you offer to promote the Predictor game?</span></p>
</li>
</ol>
<p ><span>A: We provide marketing materials (banners, video tutorials, custom pictures) in order to create promotions.</span></p>
<p ><span id="docs-internal-guid-532a2e7c-7fff-45e6-8a5a-bd772308fafc"><br /><br /><br /></span></p>`
  },
  {
    name: 'Umbrella',
    slug: 'umbrella',
    path: 'products-and-solutions/umbrella',
    icon: '',
    shortDescription: 'All about the ​​AI-powered' +
      ' risk management solution designed to identify ' +
      'and manage potential risks.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/UmbrellaKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>Umbrella</span></p>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The Risk Management Tool software product (referred to as RMT Umbrella or just RMT) is a working tool for risk managers and those users who order such a service. It&rsquo;s a </span><span>semi-automated tool developed to identify and segment risky players and decrease financial losses</span><span> for the betting operators. Designed specifically for sports betting fraud management, Umbrella is integrated into the backoffice of the SPRING platform.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The RMT is supplied with a user-friendly GUI (Graphic User Interface) for the quick and effective processing of operational information. It allows users to make proper decisions and minimise gaming company losses. Based on automated mathematical modelling, our tool establishes players&rsquo; Game Styles, Financial Categories and Additional Categories. Whenever any of the game styles are assigned to a player, the Limit and Delay values are applied appropriately.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The RMT concept is built around the following principles:&nbsp;</span></p>
<ul>
<li >
<p ><span>Ensurement of a comprehensive and high-level risk management at every stage of a player&rsquo;s journey&nbsp;</span></p>
</li>
<li >
<p ><span>Reduced human involvement by 70%</span></p>
</li>
<li >
<p ><span>Reduction of a bad turnover by at least two times&nbsp;</span></p>
</li>
<li >
<p ><span>Reduction of losses of partners with high financial risks&nbsp;</span></p>
</li>
<li >
<p ><span>Perpetual increase of the rate of identifying a negative pool&nbsp;</span></p>
</li>
<li >
<p ><span>Reduction of late bettors by an average of 7% and their detection time by 10 times&nbsp;</span></p>
</li>
<li >
<p ><span>Reduction of the detection time of multi-accounts and Game Style players</span></p>
</li>
<li >
<p ><span>Growth of the average monthly pool of VIP players, average bets, and turnover</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Product Features</span></p>
<ul>
<li >
<p ><span>Comprehensive analysis of all data at all stages of a player&rsquo;s life cycle: registration, login, deposit, gaming, withdrawal activities, etc.</span></p>
</li>
<li >
<p ><span>Automated detection of players&rsquo; behavioural algorithms and identification of multi-accounts before any financial transaction</span></p>
</li>
<li >
<p ><span>Semi-automated and manual definition of player categories as a result of the game course inquiry</span></p>
</li>
<li >
<p ><span>Mass control of the player rates based on multiple filters</span></p>
</li>
<li >
<p ><span>Ability to identify potential VIP players a few steps ahead, as well as precise determination and guarantee of objectivity</span></p>
</li>
<li >
<p ><span>Automatic processing of all client information in SportsBook products (with no exception), which manual labour cannot provide.</span></p>
</li>
<li >
<p ><span>Real-time response in case the specified algorithms and parameters coincide, regardless of peak values and the duration of client activity, as well as protection against bot programmes</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General description</span><span><br /></span><span>The Umbrella is a working tool for Risk managers and users who order such a service. It&rsquo;s specifically tailored to better support their needs and bring a sophisticated new edge to the industry.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to use the tool?</span></p>
<p ><span>The main task of the system is to identify and systematically manage players, separating them into risky and non-risky groups according to the defined criteria. The Head of the Risk Management connects the received data to Umbrella. Operators, in turn, set up the parameters, based on which the system works, categorising players as positive, negative, VIP, etc., for betting purposes. In other words, we hand over the work to operators from the Integration part: we transfer the settings to them and start to handle it.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span><span>&nbsp;</span></p>
<p ><span>Umbrella also operates as a stand-alone tool, which makes the process even easier on the basis of a correct algorithm. All it takes is to manually manage the already automated version. Based on the Partner requirements and settings, we give permission to partners&rsquo; users after which they are allowed to use our tool.&nbsp;&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Usage from the Operator&rsquo;s Point of View</span></p>
<p ><span>Umbrella is a powerful database: there are more than 100 partners who have integrated this tool. We build full integration for our partner operators providing them with all documentation and data taking into account players&rsquo; behaviour on their website and in general.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>To log in into the RMT Umbrella application, you need to open the following site first: </span><a href="https://rmt.betconstruct.com/"><span>https://rmt.betconstruct.com/</span></a><span>. Then enter your Username and Password into the corresponding fields and click the Sign In button.</span></p>
<p ><span><span><br /><br /></span></span></p>
<p ><span>FAQs&nbsp;</span></p>
<ol>
<li >
<p ><span>Q: Does the Umbrella system cover only the risks related to Sportsbook products? </span><span><br /></span><span>A: Umbrella is a complex of products designed to manage the risks of Sportsbook, Gaming, Casino, Live Casino and to prevent financial losses of the operator.</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: Is the Umbrella system automated?</span><span><br /></span><span>A: Umbrella is 80% automated and only 20% - manual, operated by risk managers.&nbsp;</span></p>
</li>
</ol>
<p ><span>Note: The player segmentation and financial limitation are performed automatically. Nevertheless, there are some restrictions/limitations (for example full or partial account blocking or game style assignment) that should be applied manually.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: Does Umbrella do player segmentation? </span><span><br /></span><span>A: Umbrella segments players based on registration information, financial KPIs, and fraudulent gaming behavior.</span></p>
</li>
</ol>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: Does Umbrella have a free trial period to use? </span><span><br /></span><span>A: Umbrella has a free trial for up to three months.&nbsp;</span></p>
</li>
</ol>`
  },
  {
    name: 'SpringBuilder',
    slug: 'springBuilder',
    path: 'content-management/springBuilder',
    icon: '',
    shortDescription: 'Create and manage your iGaming ' +
      'website with the drag-and-drop technology of' +
      ' this full-scale gaming and betting website builder.' +
      ' Powerful marketing and design tools. Highly ' +
      'customisable features. No technical skills required.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/SpringBuilderKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>General Description</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>SpringBuilder is a full-scale gaming and betting website builder highly customised to BetConstruct partners&rsquo; specific requirements. This multifunctional platform gives you a full package of powerful marketing and design tools to create and manage gaming websites as easily as possible. With our smoothly customisable features and no technical skills required, you can adjust your site to all devices.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Using SpringBuilder&rsquo;s drag-and-drop technology, you can add more than 140 pre-designed blocks and a variety of web elements to create a unique layout for your website. All you need to do is just drag your block or element from the corresponding section and drop it wherever you want.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>The complete suite of our Designer tools gives you an opportunity to set your website&rsquo;s Typography, customise the Layout and enhance the UI Kit.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>To enhance your site, you can save your time by using the Dashboard Apps. These include the Pages, Spring, Casino, Site Settings, and more. Not only are these apps easy to navigate, but they also make the process of crafting your gaming site pleasant and enjoyable.&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>How to Get Started with SpringBuilder?</span></p>
<p ><span>Here are the steps to get started:</span></p>
<p><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Create an account with BetConstruct.</span></p>
</li>
<li >
<p ><span>Go to </span><a href="https://console.betconstruct.com/"><span>SpringBME Console</span></a><span>.</span></p>
</li>
<li >
<p ><span>Sign up and verify your account.</span></p>
</li>
<li >
<p ><span>After logging in, please go to your </span><a href="https://console.springbme.com/projects"><span>Projects</span></a><span> section.</span></p>
</li>
<li >
<p ><span>Create your project by filling in the required information, such as your business. name, accepted currencies, languages, etc.</span></p>
</li>
<li >
<p ><span>Select SpringBuilder as your website search engine and pick one of the ready-made templates to begin with.</span></p>
</li>
<li >
<p ><span>That's all! You're good to go! Just edit your content and basic design. The results of your creativity will appear in the Crafting Area.</span></p>
</li>
<li >
<p ><span>Contact BetConstruct's sales team to Go Live.&nbsp;</span></p>
</li>
</ul>
<p><span><span><br /><br /></span></span></p>
<p ><span>Now you are ready to give a boost to your business.</span></p>
<p><span><span><br /><br /><br /><br /></span></span></p>
<p ><span>Product Top Features</span></p>
<ul>
<li >
<p ><span>Casino App</span></p>
</li>
<li >
<p ><span>Sportsbook Module</span></p>
</li>
<li >
<p ><span>Mobile Editor</span></p>
</li>
<li >
<p ><span>Ready-made Designs</span></p>
</li>
<li >
<p ><span>Marketing Solutions</span></p>
</li>
<li >
<p ><span>Team Management</span></p>
</li>
<li >
<p ><span>Multilingual Websites</span></p>
</li>
<li >
<p ><span>500+ Payment Methods</span></p>
</li>
<li >
<p ><span>Specialised Gaming Elements</span></p>
</li>
<li >
<p ><span>Responsive Design adjusting to all devices&nbsp;</span></p>
</li>
</ul>
<p><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span>SpringBuilder is meant to ease the process of starting an iGaming business with flexible solutions and incredibly multifunctional gaming and betting features. Operators get a chance to have a wide variety of flexible design solutions, take advantage of the feature-rich options, and have different versions of the site for desktop and mobile.&nbsp;&nbsp;&nbsp;&nbsp;</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Usage from Operators&rsquo; Point of View&nbsp;</span></p>
<p ><span>SpringBuilder is a flexible tool with design in mind, i.e. you can create any web page with any design solutions unlike CMS. SpringBuilder provides awesome tools for creating new pages, launching news or promotion sections, creating landing pages, promotional banners, adding game elements, and more. Control website settings, use our marketing tools all in one place. We also offer integrations to use 3rd party tools on any website.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<p><span><span>&nbsp;</span></span></p>
<ol>
<li >
<p ><span>Q: What is SpringBuilder?</span></p>
</li>
</ol>
<p ><span>A: SpringBuilder is a drag-and-drop iGaming website builder with a set of top-notch gaming and betting tools to create and manage websites as easily as possible, without any technical skills required.</span></p>
<p ><span>&nbsp;</span></p>
<ol start="2">
<li >
<p ><span>Q: Why should I choose SpringBuilder over BetConstruct's CMS?</span></p>
</li>
</ol>
<p ><span>A: Choosing SpringBuilder can be very beneficial for your business. We provide awesome tools for creating new pages, launching news or promotion sections, landing pages, promotional banners, and more. SpringBuilder is created with design in mind. You don't need to send any requests to your account manager to change or update the content or style of your website. Your design and marketing teams can easily manage your website and keep it up-to-date with your marketing campaigns. In addition, we provide a set of SEO tools to optimise your website for search engines.</span></p>
<p><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: What payment methods are integrated into SpringBuilder?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: SpringBuilder is integrated with all payment gateways available on the Spring Platform, including Visa, MasterCard, Neteller, WebMoney and others.</span></p>
<p><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: I liked one of the templates available in SpringBuilder. Can I change the colors of the template to match my brand guidelines?</span></p>
</li>
</ol>
<p ><span>A: Of course, you can! Your designers can use the Designer Tools app on your Dashboard to change the look and feel of all the elements used in the selected template.</span></p>
<p><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: What 3rd-party integrations are included in SpringBuilder?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: SpringBuilder is enhanced with plenty of integrations. From casino providers, like Netent and Microgaming, to marketing tools like Google Analytics, Hotjar and Intercom, Typeform, Mailchimp, Eventbrite and more.</span></p>
<p><span><span>&nbsp;</span></span></p>
<p ><span>Relation to BME</span></p>
<p ><span>SpringBuilder operates on the BME platform as a web engine for creating website with all necessary functionalities.</span></p>`
  },
  {
    name: 'Sportsbook',
    slug: 'sportsbook',
    path: 'products-and-solutions/sportsbook',
    icon: '',
    shortDescription: 'A fully-managed sports-betting' +
      ' solution that provides your players with 70,000' +
      ' live matches in 20+ languages\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/SportsbookKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Sportsbook is a fully managed sport-betting offering from BetConstruct designed to ensure operators' freedom and flexibility while managing their businesses. Our high quality solution and advanced technology match our partners&rsquo; expectations and cater for them to the fullest. Hence, an engaging player experience and higher wager values are guaranteed.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Available online as a Turnkey, White Label and API (both Iframe and SWARM) solution with mobile and native iOS/Android options, Sportsbook seamlessly works alongside the retail offering to provide operators with a comprehensive omni-channel product.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Being a leading Sportsbook provider, BetConstruct gives operators maximum autonomy, enabling them to choose any event they wish to offer (both for live and pre-match), as well as setting more competitive odds on a single match, market, sport, country or, overall, employing our advanced margin-control functionality.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The most noteworthy thing about our Sportsbook is that it&rsquo;s market-specific, i.e. the requirements of a particular region and market are completely taken into consideration. Also, it has such benefits as cash-out tools, boosted odds, statistics with historical view,&nbsp; an in-house qualified Trading Team, and it is customisable in terms of offering, limits (per sports, leagues, clients, etc.), profit, and more.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Product Features</span></p>
<ul>
<li >
<p ><span>75,000+ pre-match events every month</span></p>
</li>
<li >
<p ><span>45,000+ live matches every month</span></p>
</li>
<li >
<p ><span>120+ sports covered including Virtuals and eSports</span></p>
</li>
<li >
<p ><span>30+ languages</span></p>
</li>
<li >
<p ><span>Multi-currency and single wallet</span></p>
</li>
<li >
<p ><span>UK Horse Racing and UK bet Types</span></p>
</li>
<li >
<p ><span>PMU Betting</span></p>
</li>
<li >
<p ><span>Risk management tools</span></p>
</li>
<li >
<p ><span>Mobile, Web and Native applications for iOS and Android</span></p>
</li>
<li >
<p ><span>Five views: Classic, Modern, Asian, Combo and European</span></p>
</li>
<li >
<p ><span>Advanced betting tools: Edit Bet, BetCloud, SuperBet, Counter-offer, BetBuilder, Quickbet, Book a bet, SMS betting</span></p>
</li>
<li >
<p ><span>Cash-out types: Partial, Full, Auto</span></p>
</li>
<li >
<p ><span>Bonus types: Freebets, Accumulator Bonus, Wagering Bonus, Profit Boost</span></p>
</li>
<li >
<p ><span>Different odds formats: Decimal, Fractional, American, Hong Kong, Indo, Malay</span></p>
</li>
<li >
<p ><span>Backoffice Tools: choose markets, set margins, fix limits, view players, real-time reports</span></p>
</li>
<li >
<p ><span>Popular Competitions and Popular Matches</span></p>
</li>
<li >
<p ><span>Boosted Odds</span></p>
</li>
<li >
<p ><span>Quick Bet</span></p>
</li>
<li >
<p ><span>Brief (On-hover) Statistics and H2H Stats</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Licences</span></p>
<p ><span>BetConstruct&rsquo;s Sportsbook is available in the UK, Malta, France, Sweden, Romania, South Africa, Spain (in process), Latvia, Lithuania, Italy (in process), Germany (so far under MGA licence), Cyprus, Belarus, soon also in Denmark, Poland, Serbia. Here is the list of licences regulating in different markets to cover BC Sportsbook.</span></p>
<ul>
<li >
<p ><span>United Kingdom Gambling Commission</span></p>
</li>
<li >
<p ><span>MGA (Malta Gaming Authority)</span></p>
</li>
<li >
<p ><span>Regulatory authority for online games (ARJEL)</span></p>
</li>
<li >
<p ><span>Spelinspektionen (Swedish Gambling Authority)</span></p>
</li>
<li >
<p ><span>ONJN (Romania National Gambling Office)</span></p>
</li>
<li >
<p ><span>Western Cape Gambling and Racing Board</span></p>
</li>
<li >
<p ><span>Agenzia delle Dogane e dei Monopoli</span></p>
</li>
<li >
<p ><span>Spillemyndigheden (The Danish Gambling Authority) (in process)</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span>The Sportsbook is correlated with real life. It is a competition between players, teams, based on historical statistics. Sportsbook users are mainly sports enthusiasts who enjoy real events and, after conducting thorough analysis of the games, matches or tournaments, make predictions and place bets on live games. BetConstruct Sportsbook provides a highly attractive and feature-rich suite of products that appeals to each sports fan with incredible gaming experience and offers them unique betting options.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Set up Process</span></p>
<p ><span>Operators can set up BC Sportsbook on their websites with just one click, by choosing the default settings. Sportsbook is available both for desktop and mobile. Once it is activated, operators are able to manage the main limits of Sportsbook. The detailed customisation of the product is carried out from our Backoffice.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Usage from Operators&rsquo; Point of View</span></p>
<p ><span>Before a partner goes live, BetConstruct&rsquo;s Trading Team does research on each of the regional markets, then sets various configurations based on that, such as sports ordering, liability management, margins management, etc. that are in tune with this or that region. For example, if Cricket is popular in a particular region, priority is given to that game type.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<ol>
<li >
<p ><span>Q: Can I use management tools to decide whether to subscribe or unsubscribe?</span></p>
</li>
</ol>
<p ><span>A: Sure! We provide you with tools to manage liabilities, margins at different levels from sports to match, so that you are able to make a decent decision.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: Do you have a trading team to help us if needed?</span></p>
</li>
</ol>
<p ><span>A: Yes, we have a big in-house trading team (around 600 members) consisting of match and pre-match traders, always at your disposal.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: How many languages do you provide?&nbsp;</span></p>
</li>
</ol>
<p ><span>A: There are 30+ languages available in Sportsbook.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: How do you create profitable odds?</span></p>
</li>
</ol>
<p ><span>A: The odds are created with the help of our trading team using our own algorithms, comparison tools and live trading models.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: What is important to consider when choosing Sportsbook?</span></p>
</li>
</ol>
<p ><span>A: An effective sportsbook stands out for its multifunctionality, flexibility and other various criteria, such as the convenience of price and percentages, reliability and successful partnership - something BC Sportsbook fully provides.</span></p>`
  },
  {
    name: 'CRM',
    slug: 'crm',
    path: 'products-and-solutions/crm',
    icon: '',
    shortDescription: 'Create targeted campaigns ' +
      'with the widest range of marketing tools and player ' +
      'management solutions currently available in the market.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/CRMKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>General Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct&rsquo;s CRM (Customer Relationship Management) is a complete and independent web-based solution. It caters for our partners with everything they need. You do not have to buy or integrate any extra software, as our CRM provides the widest range of single-tool campaign and player management functions currently available in the market. It plans and executes standalone promotions, collects and analyses results, combines accuracy with deep insights and knowledge in the iGaming industry.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The Campaign Manager enables you to perform a great variety of marketing tasks, such as player base segmentation, ad-hoc marketing campaign creation, target group configuration and more. In fact, the only performance limitation is the capacity of your own server.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>CRM systems breathe life into businesses, especially those in the gaming industry. BetConstruct&rsquo;s CRM tool combines player analytics data with machine-learning algorithms to help partners better understand player behaviour. The BC CRM tool segments players into groups based on the behavioural, geographic and IP metrics they have shown on the gambling website, and this allows our users to have more targeted communication strategies.</span><span>Studying the gaming habits and preferences of players is also useful for customising and personalising offers. CRM helps partners make knowledge-based decisions by reporting and analysing the effectiveness of promotions created. And since it can cost a lot more to acquire and attract new players than to retain the existing ones, the BetConstruct CRM takes proactive measures to boost player retention and lifetime value. In addition, it aims to increase customer loyalty and reduce customer churn. In the CRM segmentation part, we have a Machine Learning based Churn Profitability filter that provides a list of players who are about to leave. Also, a RFM (Recency, Frequency and Monitoring) segmentation based on Machine Learning is available in segmentation filters. These RFM metrics are important indicators of customer behaviour, since frequency and monetary value affect the customer's lifetime value, while novelty affects retention, which is a measure of engagement. Customer retention methods include creating a loyalty / VIP programme, so we have implemented a VIP Level categorisation that can be customised according to the partner&rsquo;s requirements. Users can connect with their players through multiple channels: email, SMS, internal messages and Telegram.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Use It</span></p>
<p ><span>CRM is a web-based operational tool. To manage it, users can conduct Market Research, focus on such important metrics as retention rate or conversion rate in order to increase revenue with a proven strategy and analyse the effectiveness of the campaigns run through CRM.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Product Features</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ul>
<li >
<p ><span>Full integration with the Spring platform (including a bonus engine)</span></p>
</li>
<li >
<p ><span>Multilingual and web-based features</span></p>
</li>
<li >
<p ><span>Client segmentation with 240+ dynamic filters and their intersections</span></p>
</li>
<li >
<p ><span>Activity-triggered real-time customer journey through multiple touchpoints: registration, deposit, bet, login, etc. with instant responses</span></p>
</li>
<li >
<p ><span>Marketing campaigns through multiple channels: email, SMS, internal messaging</span></p>
</li>
<li >
<p ><span>Real-time campaign monitor</span></p>
</li>
<li >
<p ><span>Machine-Learning-based RFM (Recency, Frequency, Monitoring) segmentation</span></p>
</li>
<li >
<p ><span>Third-party messaging services providers&rsquo; integration&nbsp;</span></p>
</li>
<li >
<p ><span>Email/SMS tracking and analytics</span></p>
</li>
<li >
<p ><span>Analytics metrics, charts and reports through customisable dashboard</span></p>
</li>
<li >
<p ><span>Google calendar integration</span></p>
</li>
<li >
<p ><span>Flexible and automated report generation across some 100+ parameters</span></p>
</li>
<li >
<p ><span>On-demand custom reports with multichannel delivery scheduling service</span></p>
</li>
<li >
<p ><span>New customer acquisition through non-customer static segments &amp; leads generation</span></p>
</li>
<li >
<p ><span>High-quality support and training</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Who and what CRM is for</span></p>
<p ><span>This web-based system is intended for partners and users of BetConstruct Company product line. It is used together with the SPRING software platform as Back-end support developed by BC Company to provide end-users with what they need.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Common Markets</span></p>
<p ><span>CRM operates in almost all regions, mainly in Europe, Asia, Latin America and Africa.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Use CRM/User General Description&nbsp;</span></p>
<p ><span>CRM has 4 general sections - Dashboard, Marketing Automation, Customer Journey, Reporting, each having their own sub-sections. An Analytics section is currently under development. The Dashboard is highly customised and includes various metrics, KPIs and charts that can help users track the effectiveness of achieving their business objectives on daily/weekly/monthly bases. In the Marketing Automation section, users have a possibility to divide players into groups or segments based on various characteristics, in order to find the most profitable segments or micro-segments to sort out target groups, create templates, send out campaigns, promotions and bonuses to the players. Via CRM, it is also feasible to create event-based campaigns, by the name of Customer Journey. The main advantage of the Customer Journey is that users can instantly track players&rsquo; journeys and observe the player-product interaction. This section includes different blocks and filters, through which users can monitor players and make sure they match the criteria set in the blocks. The other important and remarkable part of the CRM system is Reports.</span><span>In fact, any report is a changeable collection of database records of player data subject to continuous updates and/or modifications on a daily basis. The Reporting section includes two basic modules: Reports and Custom Reports. Custom reports are created by the CRM development team: partners just need to put in a request. In addition, users have an opportunity to create reports by using filters and report fields (indicators) available in the system.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span>CRM can be activated from inside the SpringBME platform.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Operators&rsquo; Point of View</span></p>
<p ><span>Strong customer relationships are essential for business success. As BetConstruct&rsquo;s CRM is part of Backoffice, all the information about the players is already available in our database. On the basis of that information, partners can filter them via CRM, track their behaviour and perform detailed analysis. By means of accurate campaigns, users are capable of keeping customers engaged with their product. Along with this scrupulous customer acquisition strategy, BetConstruct&rsquo;s CRM is also a high-quality support and help desk service.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<ol>
<li >
<p ><span>Q: How many filters are there in the Dynamic segmentation section?</span></p>
</li>
</ol>
<p ><span>A: There are more than 250 filters in the Dynamic segmentation section.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: In what time zones do the filters work?</span></p>
</li>
</ol>
<p ><span>A: By default, they work in UTC +0.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: How often is the information updated in the dynamic segment?</span></p>
</li>
</ol>
<p ><span>A: Information is updated within every 24 hours.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: When&nbsp; are the generated segments and templates sent to the archive, if they have not been used?</span></p>
</li>
</ol>
<p ><span>A: The created segments and templates automatically appear in the archive list after 30 days.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="5">
<li >
<p ><span>Q: What configurations are outside the scope of CRM?</span></p>
</li>
</ol>
<p ><span>A: Bonuses are created in the Bonus Engine Department; we only get the list of bonuses created for each Partner.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="6">
<li >
<p ><span>Q: What social networks are available in the Template section?</span></p>
</li>
</ol>
<p ><span>A: Currently, we have Telegram integration. Viber integration is on its way.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="7">
<li >
<p ><span>Q: What is the difference between Real Money Bet Amount and Bet Amount?</span></p>
</li>
</ol>
<p ><span>A: The difference between these two is that Bet Amount includes bets with bonuses.</span><span><br /></span><span>*A real money bet includes bets made only from the real money balance and a portion of the real money from the deposit bonus (you deposited 50 and received a total bonus of 150 - the first bets will be included in the real money bet until they reach 50).*</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Relation to SpringBME</span></p>
<p ><span>To run the CRM product specifically, the SPRING platform should be installed and launched.</span></p>`
  },
  {
    name: 'BetCloud',
    slug: 'betCloud',
    path: 'products-and-solutions/bet-cloud',
    icon: '',
    shortDescription: 'Accept bets that exceed the pre-defined ' +
      'limits and share the risks within this virtual network ' +
      'for BetConstruct’s partner operators.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/BetCloudKB.png').default} width="689" alt="">
</div>
<br>
<p ><span>Let&rsquo;s start with understanding what Betcloud is.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>It is a virtual network for BetConstruct&rsquo;s partner operators used to accept large bets that exceed the established betting limits and share potential risks.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>General Description</span></p>
<p ><span>BetCloud is an exceptional B2B collaboration platform. With BetCloud the industry software provider BetConstruct has addressed one of the most challenging Sportsbook problems in the gaming industry, i.e. accepting &ldquo;unlimited&rdquo; bets without any risks. The product is highly beneficial for both players and operators. It is </span><span>suitable for absolutely any type of operator, regardless of its size, limits or region, and even platform providers.</span><span> By becoming a part of BetCloud network, operators can accept larger wagers without any risk of financial loss. BetCloud users inspire confidence in players who trust an operator ready to pay out their maxbet in case of a win. An operator starts off with an initial bank deposit that will later be used for all inner transactions among other BetCloud users. When a player places a large bet exceeding the operator&rsquo;s limitation, the over-limit portion of it gets automatically distributed among the BetCloud network of operators who are willing to accept this bet. There are also a number of settings that allow our partners to pre-set the bets they are ready to accept. Since the bank deposit exists, it allows to share the bet without any slowdowns and requests. And it goes without saying that all transactions made in BetCloud&rsquo;s virtual bank are recorded for security reasons.</span></p>
<p ><span>How to play</span></p>
<p ><span>When operators join BetCloud, they make an initial deposit that is used for further transactions in the cloud. On receiving large bets, an operator accepts some part of those and shares the over-limit portion, alongside its risk, with BetCloud or other users. All further operations in BetCloud follow the principles of addition to and subtraction from your initial deposit.</span></p>
<p ><span>In a nutshell, an operator becomes a part of BetCloud network by making a deposit, which the system recognises as their virtual BetCloud bank. When a player places a large bet exceeding an operator&rsquo;s limitation, the over-limit portion of it gets automatically distributed among the BetCloud network of operators.</span></p>
<p ><span>Licences</span></p>
<p ><span>BetCloud comes under the Curacao Gaming Licence.&nbsp;</span></p>
<p >&nbsp;</p>
<p ><span>Product Features</span></p>
<ul>
<li >
<p ><span>Increased sportsbook limits without any risks</span></p>
</li>
<li >
<p ><span>Boosted competitiveness in the market</span></p>
</li>
<li >
<p ><span>Encouraging players to place higher bets</span></p>
</li>
<li >
<p ><span>Attracting new VIP players and keeping the existing ones&nbsp;</span></p>
</li>
<li >
<p ><span>Inspiring trust with larger bets</span></p>
</li>
<li >
<p ><span>Higher revenues without declining any over-limit bets</span></p>
</li>
</ul>
<p >&nbsp;</p>
<p >&nbsp;</p>
<p ><span>Who and what BetCloud is exactly for</span></p>
<p ><span>BetCloud is a convenient tool mainly for our partner operators intended to boost their efficiency and player acquisition. Based on a &ldquo;principle of synergy&rdquo; for BetConstruct&rsquo;s growing stable of operators, BetCloud is part of a global network in which each of these operators can share risks with each other. Hence, we are more than certain that this solution is a very favourable gateway to your business growth, designed to make your betting experience as easy and profitable as possible.&nbsp;</span></p>
<p >&nbsp;</p>
<p ><span>Common markets</span></p>
<p ><span>BetCloud is available in all markets, mainly in Asia, ex-Soviet Republics, Africa, all under the Curacao Licence.</span></p>
<p >&nbsp;</p>
<p ><span>User General Description</span></p>
<p ><span>When it comes to the question who mostly uses BetCloud, the answer differs, considering that there are two standpoints to take into account. Let's look at the things from a player viewpoint. Imagine, it&rsquo;s the midst of a football season. The player&rsquo;s favourite team is on the field. He is a die-hard fan, ready to push all the chips in and keep fingers crossed. On the contrary, the operator is a total killjoy who rejects the bets he is not comfortable with. But the fact is that by limiting players' bets, operators limit their own revenue.</span></p>
<p >&nbsp;</p>
<p ><span>Yet, with BetCloud, players quench their drive for gambling and keep coming back to the operator that&rsquo;s ready to offer a max bet. Plus, higher bets give credibility to operators and inspire confidence in players because the latter know that their bets will always be accepted by the operator and paid in case of a win.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span>How to use BetCloud?</span></p>
<p ><span>When BetCloud is activated on a partner's website, the limit on active sports, competitions and BetCloud markets is increased, players are able to place regular bets as usual, and the over-limit part automatically goes to BetCloud. The BetCloud trigger also appears on the partner&rsquo;s website, which allows players to filter the sports available in BetCloud both in live and pre-match modes.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Once the documents are signed and the partner's deposit amount is accepted and added to Betcloud Bank, a few extra hours are needed to activate the product for the partner.</span></p>
<p ><span>&nbsp;&nbsp;</span></p>
<p ><span>Usage from Operators&rsquo; Point of View</span></p>
<p ><span>BetCloud is an online marketplace for operators that allows them to share the risk of large bets and increase their profits. Namely, sharing operators have the advantage to increase their limits without risks by 2-3 times and more, be highly competitive due to the high limits, as well as attracting VIP players and keeping the existing ones. Accepting operators, in their turn, benefit by getting filtered and low-risk bets and gaining a chance to increase profits, thus making their sportsbook more competitive in their region and attracting a larger audience. Furthermore, in case you are a BetConstruct partner, you are able to get BetCloud for free.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Technically, BetCloud works in real time. Operators do not go through various requests and confirmation stages for each BetCloud bet; the system works automatically without any requests. And, if necessary, a partner can check Betcloud reports that provide full information for every transaction.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Required Staff</span></p>
<p ><span>There is, to a great extent, no staff running the BetCloud, as everything is done on the basis of preset settings. The tool works automatically, on its own.&nbsp; Viewing the reports is the only thing that requires human intervention, if necessary.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs&nbsp;</span></p>
<ol>
<li >
<p ><span>Q: Why do I need to make a deposit for BetCloud?</span></p>
</li>
</ol>
<p ><span>A: Betcloud works in real time as usual bets, and all transactions are made automatically without any waiting times and slowdowns. That&rsquo;s why we have BetCloud Virtual bank network and deposit as a guarantee.</span></p>
<ol start="2">
<li >
<p ><span>Q: What is the minimum amount for bank deposits?</span></p>
</li>
</ol>
<p ><span>A: The bank amount scope is individual for each partner and depends on different aspects such as partner size, turnover, region, and other components. So, there is no minimum amount for the bank deposit. However, we activate BetCloud for those partners whose initial deposit is more than 3000 euros.&nbsp;</span></p>
<ol start="3">
<li >
<p ><span>Q: What is the bank transactions process like?</span></p>
</li>
</ol>
<p ><span>A: BetCloud is fully responsible for all transactions. The bank transactions process is automatic in BetCloud Virtual bank network per each accepted and shared bet.&nbsp;</span></p>
<ol start="4">
<li >
<p ><span>Q: Is there a specific list from which to select bets to be accepted?</span></p>
</li>
</ol>
<p ><span>A: As it has already been mentioned, BetCloud works in real time and automatically, so you don&rsquo;t need to waste resources to meet any bet request or requirement. Acceptance of bets from BetCloud is performed automatically according to the </span><span>Accepting settings</span><span> preset for each partner.</span></p>
<ol start="5">
<li >
<p ><span>Q: When can I withdraw my deposit?</span></p>
</li>
</ol>
<p ><span>A: You can withdraw your bank deposit in advance with the help of our financial department whenever you want.&nbsp;</span></p>
<ol start="6">
<li >
<p ><span>Q: What are the benefits of BetCloud?</span></p>
</li>
</ol>
<p ><span>A: This betting tool gives an opportunity to increase betting limits without any risks, become more competitive in the market due to high limits in Sportsbook, attract new VIP clients, as well as keeping the current ones.</span></p>
<p ><span>Relation to SpringBME&nbsp;</span></p>
<p ><span>BetCloud can be enabled and disabled via CMS, but the programme is set manually. Soon, the activation will be available on the BME platform as well.</span></p>
<p><span>&nbsp;</span></p>`
  },
  {
    name: 'Agent System',
    slug: 'agentSystem',
    path: 'products-and-solutions/agent-system',
    icon: '',
    shortDescription: 'Nourish relationships between' +
      ' agents and players. Turn those into transactions.' +
      ' Grow business and revenues in an easy, efficient' +
      ' and profitable way.',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/AgentSystemKb.png').default} width="689" alt="">
</div>
<br>
<p ><span>Description&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct&rsquo;s Agent System turns the relationships between agents and players into transactions for you, as agents recommend players to place bets and enjoy gaming based on your offer, online and offline alike.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Our system provides agents with full information about each of their players' balance and bet history. An agent's reward is based on the commission on the income generated by every player they recommend.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>A well-run agent network has the capability to leverage multiple agents' personal contacts by transforming recommendations into new players, new revenue streams and increased profits. Since the agent's commission cost is not fixed, their payout is linked to the operator profit. Operators have complete access to all the same information held by each of their agents, as well as complete overview of the risk status within the system and the amounts wagered and won. They also have full access to the profits by individual agents and those aggregated. With a full view of all players' accounts, they can calculate the risks and adjust odds ahead of taking bets.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>The Agent System favours gaming websites that open up new revenue channels for the business and drive essential traffic to casino games and sports betting as a result of efficient monitoring and administration performed by operators and agents. Our agent system has recently been fully equipped with the latest technological advancements and is now even more user-friendly than ever.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Use It</span></p>
<p ><span>To run the Agent System, operators create agents and players, set up permissions, system commissions and do other essential configurations in the system. Our Agent System is multi-level: it enables operators to include as many levels of agents for the operation as necessary. The operator tops up the system wallet with a certain amount of money in order to make real time transfers to agents&rsquo;/players&rsquo; balances. Once a deposit or withdrawal is made, a player&rsquo;s balance is immediately filled up: this allows him to start playing.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Features</span></p>
<ul>
<li >
<p ><span>Complete transparency and control over all incoming cash streams</span></p>
</li>
<li >
<p ><span>Full information on income and expenditure</span></p>
</li>
<li >
<p ><span>Increase of players&rsquo; effective spend time</span></p>
</li>
<li >
<p ><span>Cross-platform and cross-device</span></p>
</li>
<li >
<p ><span>Cross-currency reporting</span></p>
</li>
<li >
<p ><span>Full transaction overview including real and credit transactions</span></p>
</li>
<li >
<p ><span>Multi-currency operation</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Who and what the Agent System is for</span></p>
<p ><span>The product is neatly designed for operators who want to receive high profits on the website without using payment methods. Players are created by agents directly from the system and the transfer of funds to balances is fulfilled immediately, thus enabling players to play without using online payment methods.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Common Markets</span></p>
<p ><span>The markets in which the Agent System is widely used are specific. They depend on the operators&rsquo; markets.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span>System users are created by system operators only. Since the system deals with cash transactions, the staff should know all the agents they register in the system. The system better supports the users' needs and caters for operators with everything they need.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Use the Product</span></p>
<p ><span>To use the product, one should create players in the system, make the necessary transfers to their balances and track their activity in reports. All transactions and sport bets are real-time, meaning that you can track them immediately in the system.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span>To start, you provide the required information to us, and we do the setup for you. You are given a Master Admin account with full access, while all commissions and permissions are set up according to your business model.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Operator&rsquo;s Point of View</span></p>
<p ><span>Our Agent System is highly customised to the demands of the operators and their players. Operators, in turn, create users, top up the system wallet with funds and make the necessary transfers in the system, enabling agents to make transactions. They make the required configurations by selecting products, defining permissions per role, adding new currencies, etc.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<ol>
<li >
<p ><span>Q: What should I do when I first open the Agent System?</span></p>
</li>
</ol>
<p ><span>A: You should configure your system before starting to work with it. Create commissions, define permissions, set up costs, make wallet corrections and only then run the system.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: Can I change the default commission plan of the system?</span></p>
</li>
</ol>
<p ><span>A: Sure! You can change your system&rsquo;s default commission plan whenever you want.&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: Can I pay my agents their commissions every week, as opposed to the monthly basis?</span></p>
</li>
</ol>
<p ><span>A: We have both manual and monthly calculations. You select the one that suits you and your business best.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: Is it possible to pay commission not from the NGR but from the Net Deposit?</span></p>
</li>
</ol>
<p ><span>A: Yes it is, as we have a Net Deposit commission plan.</span></p>
<p><span>&nbsp;</span></p>`
  },
  {
    name: 'Affiliate Marketing',
    slug: 'affiliateMarketing',
    path: 'products-and-solutions/affiliate-marketing',
    icon: '',
    shortDescription: 'One of the most complete affiliate ' +
      'creation and management solutions in the iGaming market today.\n',
    description: `
<div><img src=${require('../assets/imgs/innerIcons/AffiliateMarketingKb.png').default} width="689" alt="">
</div>
<br>
<p ><span>Description</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>BetConstruct&rsquo;s Affiliate Marketing Software is one of the most complete affiliate creation and management solutions in the iGaming market today. This convenient and user-friendly tool makes it possible for affiliates to drive quality traffic to operators&rsquo; websites via comprehensive reports, market-required commission types and a package of innovative marketing techniques. It enables our partners to easily set up, expand and manage their affiliate network without the need for a more complex additional technology. The fully customised Affiliate Software ensures outstanding user experience and breathes life into your affiliate business. This is a useful and easy-to-handle tool that provides affiliates with an opportunity to earn attractive payouts. It lets gaming sites take over online marketing campaigns by quickly and easily tracking affiliates.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Use </span><span>It</span></p>
<p ><span>It is quite easy to use BetConstruct&rsquo;s Affiliate Marketing system. First, you receive and confirm requests for affiliate registration. Players are brought to the website via links, banners, promo codes and some other ways the system offers. According to the revenue they bring to the company, they receive commissions based on the deal they work with.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Features</span></p>
<ul>
<li >
<p ><span>Instantly updated odds on banners and odds comparison websites</span></p>
</li>
<li >
<p ><span>Customisable Commission Plan for individual affiliates and multi-branding</span></p>
</li>
<li >
<p ><span>Fully manageable commission conditions per product type level&nbsp;</span></p>
</li>
<li >
<p ><span>Attractive referral commissions</span></p>
</li>
<li >
<p ><span>Advanced tracking, complete statistics and detailed reporting&nbsp;</span></p>
</li>
<li >
<p ><span>Web-based admin panel supporting desktop and mobile versions</span></p>
</li>
<li >
<p ><span>Multilingual, multicurrency and multi-domain features&nbsp;</span></p>
</li>
<li >
<p ><span>Internal messaging for communication with affiliates&nbsp;</span></p>
</li>
<li >
<p ><span>Sending bulk newsletters to your affiliates&nbsp;</span></p>
</li>
<li >
<p ><span>Customisable affiliate software page</span></p>
</li>
<li >
<p ><span>Monthly and manual calculation types&nbsp;</span></p>
</li>
<li >
<p ><span>Negative and non-negative carry-over types&nbsp;</span></p>
</li>
<li >
<p ><span>Server-to-server postback tracking</span><span>&nbsp;</span></p>
</li>
<li >
<p ><span>API integration</span></p>
</li>
<li >
<p ><span>Innovative marketing tools including banners, JSON/ XML feed and Banner Management Program in HTML5</span></p>
</li>
<li >
<p ><span>Multiple search criteria, bulk actions for affiliate groups, reward plans and marketing messages</span></p>
</li>
</ul>
<p ><span><span><br /><br /><br /></span></span></p>
<p ><span>Who and what Affiliate Marketing is for?&nbsp;</span></p>
<p ><span>The product is aimed at those who want to receive high profits on their website by means of wider appeal and increased player traffic, as well as the affiliates interested in cooperating with the operator..&nbsp;&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Common Markets</span></p>
<p ><span>The product is open to all markets.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>User General Description</span></p>
<p ><span>Anyone who can</span></p>
<ul>
<li >
<p ><span>meet the terms and conditions of the system;&nbsp;</span></p>
</li>
<li >
<p ><span>promote the system links and banners in other marketing sources;&nbsp;</span></p>
</li>
<li >
<p ><span>use various marketing channels to make profits;&nbsp;</span></p>
</li>
<li >
<p ><span>augment conversions to operators&rsquo; websites.</span></p>
</li>
</ul>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>How to Use the Product</span></p>
<p ><span>To use the product, you&rsquo;ll need to register for it. As soon as the admins approve your request, you will be able to add your marketing sources, create links, banners and get started. You can check and see every single click on your banners, alongside impressions, right in your marketing report.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Setup Process</span></p>
<p ><span>To get started, you provide the required information to us, and we do the setup for you. You are given a master admin account with full access, while all commissions and permissions are set up according to your business model.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>Operator&rsquo;s Point of View</span></p>
<p ><span>Affiliate Marketing opens up opportunities for operators to allow individuals to promote their operations in all marketing channels. It helps them find and attract new audiences. Operators make the necessary configurations in the system, add the roles they need, define permissions both globally and individually. They add banners, landing pages, etc., and share the necessary stuff with their affiliates.&nbsp;&nbsp;</span></p>
<p ><span><span>&nbsp;</span></span></p>
<p ><span>FAQs</span></p>
<ol>
<li >
<p ><span>Q: Who can register as an affiliate?</span></p>
</li>
</ol>
<p ><span>A: Anyone who agrees to work under the system terms and conditions.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="2">
<li >
<p ><span>Q: How long does it take to activate the Affiliate System?</span></p>
</li>
</ol>
<p ><span>A: The activation of the system takes 2-5 working days. All you need to do is provide us with the required information. We will do the setup for you.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="3">
<li >
<p ><span>Q: Can I pay my affiliates their commissions every week, as opposed to the monthly basis?</span></p>
</li>
</ol>
<p ><span>A: Sure! We have both manual and monthly calculations. You select the one that suits you and your business best.</span></p>
<p ><span><span>&nbsp;</span></span></p>
<ol start="4">
<li >
<p ><span>Q: What's the difference between manual and monthly calculations?</span></p>
</li>
</ol>
<p ><span>A: A monthly calculation happens on every 1st day of each month, whereas you perform a manual calculation manually, by clicking the "Calculate Now" button.</span></p>`
  },
];

export const Menu = [
  {
    name: 'Description',
    slug: 'description',
  },
];

export const SERVICES_MENU=[
  {
    name: 'Description',
    slug: 'description',
  },
  {
    name: 'Pricing',
    slug: 'pricing',
  },
]
